var gtmChars = SDG.Data.gtm_chars.split(',') || [];
const isJapanLocale = SDG.Data.locale === '/ja-jp' || SDG.Data.locale === '/en-jp';
const currencyFormat = SDG.Data.toLocaleString;
const localeStringParam = {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
};

var pdpErrorScrollTracked = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
var pdpErrorScrollFallbackTracked = [];

function isPdpErrorVisible(element) {
  if (!element) return false;
  if (element.classList.contains('hide')) return false;
  if (element.classList.contains('js-add-size-to-cart-error') && !element.classList.contains('is-visible')) {
    return false;
  }
  var style = window.getComputedStyle(element);
  return style.display !== 'none' && style.visibility !== 'hidden';
}

function scrollPdpWarningIntoView(element) {
  if (!element || !window.matchMedia('(max-width: 1060px)').matches) return;

  window.requestAnimationFrame(function () {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
}

function isPdpErrorTracked(element) {
  if (pdpErrorScrollTracked) return pdpErrorScrollTracked.has(element);
  return pdpErrorScrollFallbackTracked.indexOf(element) !== -1;
}

function trackPdpError(element) {
  if (pdpErrorScrollTracked) pdpErrorScrollTracked.add(element);
  else if (pdpErrorScrollFallbackTracked.indexOf(element) === -1) {
    pdpErrorScrollFallbackTracked.push(element);
  }
}

function untrackPdpError(element) {
  if (pdpErrorScrollTracked) pdpErrorScrollTracked.delete(element);
  else {
    var idx = pdpErrorScrollFallbackTracked.indexOf(element);
    if (idx !== -1) pdpErrorScrollFallbackTracked.splice(idx, 1);
  }
}

function scrollPdpErrorIfVisible(element) {
  if (!element) return;
  if (!isPdpErrorVisible(element)) {
    untrackPdpError(element);
    return;
  }
  if (isPdpErrorTracked(element)) return;
  trackPdpError(element);
  scrollPdpWarningIntoView(element);
}

window.scrollPdpWarningIntoView = scrollPdpWarningIntoView;
window.scrollPdpErrorIfVisible = scrollPdpErrorIfVisible;

function upsellAllowLimit(){
    if($(".template-product").length>0 && $(".upsell-container").length>0){
      let allowLimit = 0;
      $(".upsell-container .grid.grid--large").each(function() {
        let thisE = $(this);
        if(!thisE.hasClass('disable-grid')){
          let plimit = thisE.attr('data-limit');
          plimit = parseInt(plimit);
          allowLimit = allowLimit + plimit;
        }

      })
      if(allowLimit >0){
        $(".product__add-to-cart").attr('allow-limit',allowLimit)
      }
  }
}
function errorHandling(){
    // Skip for combined listings - they handle their own error state
    if ($('#combinedListing').length > 0) {
        return;
    }

    var findError = $(".warning-msg.bold.limited");
    var upsellp = $(".upsell-container");
    if(upsellp.length>0){
        var upGrid = upsellp.find(".grid");
        var upGridDis = upsellp.find(".grid.disable-grid");
        if(upGrid.length != upGridDis.length){
        $(".tnc-container").removeClass('hide');
            $(".product__prices").removeClass('hide');
        $(".warning-msg.bold.limited").addClass('hide');
        }
        else{
        if(findError.length>0){
            $("#product_limit").next().removeClass('hide');
            $(".tnc-container").addClass('hide');
            $(".product__prices").addClass('hide');
            $("#add-to-cart-btn").addClass("sold-out-btn").attr("disabled", "disabled")
            $(".pdp-sticky-atc").addClass("sold-out-btn").attr("disabled", "disabled")
        }
        }
    }
    else{
        if(findError.length>0){
            $(".tnc-container").addClass('hide');
            $(".product__prices").addClass('hide');
        }
    }
}
$(document).ready(function(){
  upsellAllowLimit();
  if ($(".template-customers-addresses")[0]){
      setAddressheight();
  }
   if ($(".template-customers-account")[0]){
    if($(window).width()<=560){
        $('.start-shopping-button').insertAfter('.customer__orders table');
    }
  }
if ($(".launch-calendar")[0]){
    $('.calendar-loader').addClass('showloader');
     $('.calendar-loader').append('<div class="loaderelement"></div>');
    $('.calendar-events-wrapper div[class*="elfsight-"]').css('height','0').css('opacity','0');
     var checkExist = setInterval(function() {
       if ($('.eapp-events-calendar-grid-item').length) {
            clearInterval(checkExist);
            filteredUrl();
            gridFilterclick();
            window.scrollTo({ top: 0, behavior: 'smooth' });
       }
     }, 100);
     browserBackBtnClick();

}
   if ($(".calendar-section")[0]){
    launchCustomcalendar();
  }
    var page_id = $("#page_id_val").val();
    if (sessionStorage.newsletterSubscribed) {
    $("#signupError").html($('.signup-email .subscribe').data('success'));
    if ($("#signupError")[0]){
        // $('html, body').animate({
        //     scrollTop: $('#signupError').offset().top
        // }, 'slow');
    }
    }
    $('.js-cart-agree-check').change(function() {
        if(this.checked) {
            $(`.${$(this)[0].dataset.for}`).removeClass("error-active");
            $(".js-cart-agree-alert")[0].hidden = true;
            $(".js-cart-pay-buttons").addClass("show-shopbay");
            $(this).closest('.js-cart-item').find('.js-cart-agree-error').attr('hidden', '');
        }
        else{
            $(".js-cart-pay-buttons").removeClass("show-shopbay");
        }
        $(`.${$(this)[0].dataset.for}`).prop('checked',this.checked);
    });
    $(".js-cart-checkout").on("click",function(e){
        e.preventDefault();
        sessionStorage.setItem('cart-locale', Shopify.routes.root);
        var membership_checkboxes = document.querySelectorAll(".js-cart-agree-check");
        var individual_membership_pdp = document.querySelectorAll('.js-pdp-agreement');

        if (membership_checkboxes !== undefined && membership_checkboxes.length > 0) {
          var checkedFlag = true;
          membership_checkboxes.forEach(element => {
            if (!element.checked) {
              checkedFlag = false;
              element.classList.add("error-active");
              $(element).closest('.js-cart-item').find('.js-cart-agree-error').removeAttr('hidden');
            } else {
              element.classList.remove("error-active");
              $(element).closest('.js-cart-item').find('.js-cart-agree-error').attr('hidden', '');
            }
          });

          if(checkedFlag) {
            $("#cartCheckout").click()
          } else {
            document.querySelector(".js-cart-agree-alert").hidden = false;
          }
          if (checkedFlag === false) return;
        }

        if (individual_membership_pdp.length > 0) {
          var checkedIndividualFlag = true;
          individual_membership_pdp.forEach((element) => {
            if (!element.checked) {
              checkedIndividualFlag = false;
              element.parentElement.parentElement.classList.add('error-active');
            } else {
              element.parentElement.parentElement.classList.remove('error-active');
            }
          });
          if (checkedIndividualFlag === false) {
            var $errorMessageCallouts = document.querySelectorAll('.js-membership-pdp-agreement');
            if ($errorMessageCallouts && $errorMessageCallouts.length > 0) {
              $errorMessageCallouts.forEach((item) => {
                item.removeAttribute('hidden');
              });
            }
            return;
          };
        }

        $("#cartCheckout").click()
    });
    $('.js-pdp-agreement').on('change', function() {
      if (!this.checked) return;
      this.parentElement.parentElement.classList.remove('error-active');
      var $errorMessageCallouts = document.querySelectorAll('.js-membership-pdp-agreement');
      if ($errorMessageCallouts && $errorMessageCallouts.length > 0) {
        $errorMessageCallouts.forEach((item) => {
          item.setAttribute('hidden', '');
        });
      }
    });
    $('.signup-email .subscribe').on('click',function(){
        emailInput=$('.signup-email .enter-email').val();
        var emailRegex=/^([a-zA-Z]+[a-zA-Z0-9_\-\+\.]+)@((([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if(emailInput==""){
                $("#signupError").addClass('active').stop().delay(500).queue('',function(){
                    $(this).removeClass('active');
                });
                $("#signupError").html($(this).data('empty'))
        }
        else if(!emailRegex.test(emailInput)){
                $("#signupError").addClass('active').stop().delay(500).queue('',function(){
                    $(this).removeClass('active');
                });
                $("#signupError").html($(this).data('error'))
        }
        /*else if($('#user-subscription').not(':checked').length > 0){
            console.log('User subscription needed !!');
        }*/
        else{
            //registerEmailAddress(emailInput);
            $("#Email-footer").val($("#emailAddress").val());
            //triggerTags("email subscription","click", page_id+"__want to know about future drops_email submit","","","")
            $("#shopify-section-newsletter.newsletter__form").submit();
            sessionStorage.setItem("newsletterSubscribed", "true");
        }
    });
    $('#accept-terms-conditions').change(function() {
        if(this.checked) {
            $(this).removeClass("error-active");
            $(".warning-msg.error").hide();
            $("#add-to-cart-btn").removeClass("atc-error-color");
            $(".pdp-sticky-atc").removeClass("atc-error-color");
        }
        $('#textbox1').val(this.checked);
        if (typeof SDG.pdpQuickpaySync === 'function') {
          SDG.pdpQuickpaySync();
        }
    });
    $(".cart-button").on("click",(e)=>{
        //var currProduct = $("#products-to-add").val();
        e.preventDefault();
        var currCartCount = $(".header__cart-count:first").text();
        var array = new Array();
        var prodToAdd = $("#prod_to_add").val();
        array.push(prodToAdd);
        addAllItems(array.toString(),currCartCount);
    });
    // Change ATC button to normal when unchecked
    $('.digital-memb').on('change', function() {
      if (!$(this).is(':checked')) {
        $('#add-to-cart-btn').removeClass("atc-error-color");
      }
    });
    $("#add-to-cart-btn, #productSizeSubmit").on("click",(e)=>{
        e.preventDefault();

        // New Upsell PDP: a selected companion is bought as its own variant, so
        // the hero's size selector is hidden and has nothing to validate.
        var $upsellOption = document.querySelector('.js-product-upsell-option:checked');
        var isUpsellCompanion = Boolean(
          $upsellOption
          && $upsellOption.dataset.isHero !== 'true'
          && $upsellOption.dataset.variantId
        );

        var isSizedProduct = e.target.id === 'productSizeSubmit';
        var isCombinedListing = $('#combinedListing').length > 0;
        var noSizeSelected = false;
        if (isUpsellCompanion) {
          noSizeSelected = false;
        } else if (isSizedProduct && $('#sizeList').length > 0) {
          noSizeSelected = $('#sizeList input:checked').length > 0 ? false : true;
        } else if (isCombinedListing && $('.js-combined-item-input-size').length > 0) {
          noSizeSelected = $('.js-combined-item-input-size:checked').length === 0;
        }
        // do not add to cart if sized product has no size selected
        if (noSizeSelected) {
          var $sizeError = $('.js-add-size-to-cart-error');
          $sizeError.addClass('is-visible');
          scrollPdpErrorIfVisible($sizeError[0]);
          return;
        } else {
          $('.js-add-size-to-cart-error').removeClass('is-visible');
        }

        // A selected companion that is not membership-gated is a regular
        // product, so it must add without the hero PDP's membership checks.
        if (isUpsellCompanion && $upsellOption.dataset.requiresMembership !== 'true') {
          $(".product__membership-error").addClass("hide");
          $(".warning-msg.error, .warning-msg.membership-agreement").hide();
          $("#add-to-cart-btn, .pdp-sticky-atc").removeClass("atc-error-color");

          var upsellVariantId = String($upsellOption.dataset.variantId);
          addAllItems(
            upsellVariantId,
            $(".header__cart-count:first").text(),
            {
              id: upsellVariantId,
              properties: {
                _item_list_type: 'product upsell',
              },
              quantity: Number($('.js-qty-input').val()) || 1,
            },
            [{
              _item_list_type: 'product upsell',
            }]
          );
          return;
        }

        var isChecked = $(".digital-memb").is(":checked");
        var isDisabled = $(".digital-memb").is(":disabled");
        var isDigitalMembership = SDG?.Data?.isDigitalMembership && !$(".grid__membership-upsell").length;
        var isExclusiveMember = typeof SDG?.Data?.isExclusiveMember === 'string' ? SDG?.Data?.isExclusiveMember?.split(',').includes(SDG?.Data?.exclusiveBrand) : SDG?.Data?.isExclusiveMember;
        var isExclusiveCustomer = SDG?.Data?.isCustomer && isExclusiveMember;

        var shouldApplyErrorStyles =
          !isChecked &&
          !isDisabled &&
          !isDigitalMembership &&
          (!SDG?.Data?.isCustomer || !isExclusiveCustomer) &&
          !isSizedProduct;

        if (shouldApplyErrorStyles) {
          var closestParentGrid = $(".digital-memb").closest(".grid");
          closestParentGrid.css("border", "1px solid #ee0224");
          $(".product__membership-error").removeClass("hide").each(function () {
            scrollPdpErrorIfVisible(this);
          });
          $(".product__add-to-cart").addClass("atc-error-color");
          $(".membership-agreement").css({
            "display": "none",
          });
          $(".digital-memb").siblings("label").css({
            "background": "none",
            "border": "1px solid red"
          });
          return;
        }

        var closestParentGrid = $(".digital-memb").closest(".grid");
        closestParentGrid.css("border", "1px solid #7b7b7b");
        $(".product__membership-error").addClass("hide");

        // var currProduct = $("#products-to-add").val();
        var currCartCount = $(".header__cart-count:first").text();
        var array = new Array();
        var properties = {};
        var mainProduct = {};
        if ($upsellOption) {
          properties._item_list_type = 'product upsell';
        }
        if($("#item_atp_receipt_id").val() != null && $("#item_atp_receipt_id").val() != "") {
            properties["_item_atp_receipt_id"] = $("#item_atp_receipt_id").val();
        }
        if($("#expire_soon").val() != null && $("#expire_soon").val() != "") {
      properties["_membership_expiring_soon"] = $("#expire_soon").val();
    }
        var otherProductProperties = [];
        var otherProperty = {};
        if (isSizedProduct && !noSizeSelected && !$(".upsell-container").length) {
          const { productId } = SDG.Data;
          const sizedProductVariant = $(`#product-select-${productId}[name="id"]`).val();
          if (sizedProductVariant) {
            array.push(sizedProductVariant);
          }
        };
        // Check for combined listing product variant
        var combinedListingVariant = $('#products-to-add').val();
        if (combinedListingVariant && combinedListingVariant !== '' && $('#combinedListing').length) {
          array.push(combinedListingVariant);
        }

        // array.push(currProduct);
        $(".upsell-container .grid:not(.disable-grid) input[type='checkbox']:checked").each(function () {
            otherProperty = {};
            var vals = $(this).attr("id");
            var message = $(this).attr("data-variant-inventorystatus");
            var date = $(this).attr("data-variant-backorderdate");
            var recipt_id = $(this).attr("data-item-atp-receipt-id");
            if(recipt_id != undefined && recipt_id != "") {
                otherProperty._item_atp_receipt_id = recipt_id;
            }
            otherProperty._upgrade_option = 'upsell';
            // Membership upsell: attach agreement props so checkout stays pre-checked
            if ($(this).hasClass('digital-memb') && $('input#accept-terms-conditions').is(':checked')) {
              otherProperty._is_digital_membership = 'true';
              otherProperty._agreement_checked = 'true';
              otherProperty._membership_no_agreement = 'false';
            }
            otherProductProperties.push(otherProperty);
            array.push(vals)
        });

        // Member exclusive PDPs render the PDP product as its own upsell checkbox,
        // so an unchecked box means the shopper wants the membership only.
        var mainUpsellId = $('#prodId').val() || $('#product_id').val() || $('#products-to-add').val();
        var $mainUpsellCheckbox = $(".upsell-container input[type='checkbox']").filter(function () {
          return $(this).attr('id') === String(mainUpsellId);
        });
        var mainUpsellDeselected = $mainUpsellCheckbox.length > 0 && !$mainUpsellCheckbox.is(':checked');

        // When membership upsell is selected, always include the main PDP product too
        if ($('input.digital-memb').is(':checked') && !mainUpsellDeselected) {
          if (mainUpsellId && array.indexOf(String(mainUpsellId)) === -1) {
            array.unshift(String(mainUpsellId));
            otherProductProperties.unshift({ _upgrade_option: 'upsell' });
          }
        }
        if($(".upsell-container input[type='checkbox']").length == 0){
            if($('#cart_btn_state').val()=="enable"){
                    otherProperty = {};
                var message = $('#variant_inventory_status').val();
                var date = $('#variant_back_orderdate').val();
                var recipt_id = $('#item_atp_receipt_id').val();
                var expireSoon =$('#expire_soon').val();
                if(recipt_id != undefined && recipt_id != "") {
                    otherProperty._item_atp_receipt_id = recipt_id;
                }
                if(expireSoon != undefined && expireSoon != "") {
                    otherProperty._membership_expiring_soon = expireSoon;
                }
                otherProductProperties.push(otherProperty);
                array.push($('#product_id').val());
            }
        }

        // When the PDP product is deselected, array[0] is the membership, so keep
        // mainProduct pointing at the PDP product and flag it as excluded instead.
        mainProduct["id"] = mainUpsellDeselected ? String(mainUpsellId) : array[0];
        mainProduct["properties"] = properties;
        mainProduct["quantity"] = Number($('.js-qty-input').val());
        mainProduct["isDeselected"] = mainUpsellDeselected;
        if ($('#membershipPdp').length && !isSizedProduct) {
          mainProduct["isMembershipPdp"] = true;
        }

        const $membershipsSelect = document.querySelector('.js-memberships-select');
        const membershipSelectDisabled = $membershipsSelect ? $membershipsSelect.disabled : undefined;

        if ($membershipsSelect && !membershipSelectDisabled) {
          if ($membershipsSelect.value === '') {
            const $membershipError = document.querySelector('.js-membership-error');
            if ($membershipError) {
              $membershipError.classList.remove('hide');
              scrollPdpErrorIfVisible($membershipError);
            }
            return;
          }
          const termsClass = document.querySelector("#accept-terms-conditions");
          if(termsClass) {
            if(!termsClass.checked || ($membershipsSelect && membershipSelectDisabled)){
              const $membershipAgreeError = document.querySelector('.warning-msg.membership-agreement');
              const $checkboxContainer = document.querySelector('.checkbox-container');
              if ($membershipAgreeError) {
                $membershipAgreeError.style.display = 'flex';
                scrollPdpErrorIfVisible($membershipAgreeError);
              }
              if ($checkboxContainer) {
                $checkboxContainer.classList.add('error');
              }
              return;
            }
          }
          otherProperty = {};
          otherProperty._upgrade_option = 'upsell';
          otherProperty._is_digital_membership = 'true';
          otherProperty._agreement_checked = 'true';
          otherProperty._membership_no_agreement = 'false';
          otherProductProperties.push(otherProperty);
          if (
            $membershipsSelect &&
            !$membershipsSelect.parentNode.parentNode.classList.contains('pv-memberships--disabled')
          ) {
            array.push($membershipsSelect.value);
          }
        }

        if ($(".digital-memb")[0] || SDG.Data.isDigitalMembership){
            if ($('input.digital-memb').is(':checked')){
                if ($('input#accept-terms-conditions').is(':checked')) {
                    addAllItems(array.toString(),currCartCount,mainProduct,otherProductProperties);
                    $(".warning-msg.error").hide();
                    $("input#accept-terms-conditions").removeClass("error-active");
                }else{
                    $("#add-to-cart-btn").addClass("atc-error-color");
                    $(".pdp-sticky-atc").addClass("atc-error-color");
                    $(".pdp-sticky-atc").removeClass("button--loading pdp-sticky-atc--loading").removeAttr("disabled");
                    $(".warning-msg.error").show().each(function () {
                      scrollPdpErrorIfVisible(this);
                    });
                    $("input#accept-terms-conditions").addClass("error-active");
                }
            } else if (
              ($('input.digital-memb').length && $('#upsell-section .grid.disable-grid').length === 0 && !$('input.digital-memb').is(':checked'))
              ||
              (SDG.Data.isDigitalMembership && !$('input#accept-terms-conditions').is(':checked'))
            ) {
              // This condition is met when legacy membership upsell is displayed or
              // Product is Digital Membership and does not have terms and conditions checked
              const $membershipError = document.querySelector('.product__membership-error');
              if ($membershipError) {
                $(".digital-memb").siblings("label").css({
                  "background": "none",
                  "border": "1px solid red"
                });
                $membershipError.classList.remove('hide');
                scrollPdpErrorIfVisible($membershipError);
              }
            } else {
              addAllItems(array.toString(),currCartCount,mainProduct,otherProductProperties);
              $(".warning-msg.error").hide();
              $("input#accept-terms-conditions").removeClass("error-active");
            }
        }
        else if($('#digital_membership').val()=="enabled"){
            if ($('input#accept-terms-conditions').is(':checked')) {
                addAllItems(array.toString(),currCartCount,mainProduct,otherProductProperties);
                $(".warning-msg.error").hide();
                $("input#accept-terms-conditions").removeClass("error-active");
            }else{
                $("#add-to-cart-btn").addClass("atc-error-color");
                $(".pdp-sticky-atc").addClass("atc-error-color");
                $(".pdp-sticky-atc").removeClass("button--loading pdp-sticky-atc--loading").removeAttr("disabled");
                $(".warning-msg.error").show().each(function () {
                  scrollPdpErrorIfVisible(this);
                });
                $("input#accept-terms-conditions").addClass("error-active");
            }
       }
        else{
            addAllItems(array.toString(),currCartCount,mainProduct,otherProductProperties);
            $(".warning-msg.error").hide();
            $("input#accept-terms-conditions").removeClass("error-active");
        }
    })

    // Hide size error when a combined listing size is selected
    $(document).on("change", ".js-combined-item-input-size", function () {
        if ($(this).is(':checked')) {
          $('.js-add-size-to-cart-error').removeClass('is-visible');
        }
    });

    $(document).on("click", ".upsell-container input[type='checkbox']", function () {
        if (SDG.Data.is_exclusive_pdp) return;
        var mainProductprice = $("#product-price").val();
        var currTotal = parseFloat($(".bundle-total:first").text().replace(",","").replace(",","").replace(".","").replace(".", ""));
        var unitPrice = parseFloat($(this).data("price").toString().replace(",",''));

        var newTotal;
        if($(this).is(':checked')){
            newTotal = currTotal + unitPrice;
            newTotal = newTotal / 100;

            $(".bundle-total").text(newTotal.toLocaleString(currencyFormat, localeStringParam));
            if(newTotal == 0){
                $(".product__prices").hide();
            }else{
                $(".product__prices").show();
            }
        }else{
            newTotal = currTotal - unitPrice;
            newTotal = newTotal / 100;

            $(".bundle-total").text(newTotal.toLocaleString(currencyFormat, localeStringParam));

            if(newTotal == 0 ){
                $(".product__prices").hide();
            }else{
                $(".product__prices").show();
            }
            //$(".tnc-container").hide();
        }
        if ($('input.digital-memb').is(':checked')){
            $(".tnc-container").show();
            $(".digital-memb").siblings("label").removeAttr("style");
        }else{
            $(this).removeAttr("checked");
            $(".tnc-container,.membership-agreement").hide();
            $(".pdp-sticky-atc").removeClass("atc-error-color").removeAttr("disabled");
            $("#add-to-cart-btn").removeClass("atc-error-color").removeAttr("disabled");
            $("#accept-terms-conditions").prop("checked", false);
        }
        if (typeof SDG.pdpQuickpaySync === 'function') {
          SDG.pdpQuickpaySync();
        }
        if($(".upsell-container input[type='checkbox']:checked").length <= 0){
            $(".pdp-sticky-atc").addClass("sold-out-btn").attr("disabled", "disabled");
            $("#add-to-cart-btn").addClass("sold-out-btn").attr("disabled", "disabled")
        }else{
            $(".pdp-sticky-atc").removeClass("sold-out-btn").removeAttr("disabled");
            $("#add-to-cart-btn").removeClass("sold-out-btn").removeAttr("disabled")
        }
    });
    if ($(".upsell-container")[0]){
      var mainProductprice = $("#product-price").val();
        var currTotal = 0;
        $('input:checkbox:checked.upsell-products').each(function () {
          var unitPrice = parseFloat($(this).data("price").toString().replace(",",''));
          currTotal+=unitPrice;
       });
        if($(".upsell-container input[type='checkbox']")[0]){
          if($(".upsell-container input[type='checkbox']:checked").length <= 0){
            $(".pdp-sticky-atc").addClass("sold-out-btn").attr("disabled", "disabled")
            $("#add-to-cart-btn").addClass("sold-out-btn").attr("disabled", "disabled")
          }else{
            $(".pdp-sticky-atc").removeClass("sold-out-btn").removeAttr("disabled")
            $("#add-to-cart-btn").removeClass("sold-out-btn").removeAttr("disabled")
          }
        }
        else{
          // currTotal=parseFloat($('#prod_price').val().replace(/,/g,''));
          currTotal=parseFloat($('#prod_price').val());
          if($('#cart_btn_state').val()=="enable"){
            $("#add-to-cart-btn").removeClass("sold-out-btn").removeAttr("disabled")
          }
          else if($('#cart_btn_state').val()=="disable"){
            $("#add-to-cart-btn").addClass("sold-out-btn").attr("disabled", "disabled")
          }
       }
       /*if($(".upsell-container input[type='checkbox']:checked").length <= 0){
            $("#add-to-cart-btn").addClass("sold-out-btn").attr("disabled", "disabled")
        }else{
            $("#add-to-cart-btn").removeClass("sold-out-btn").removeAttr("disabled")
        }*/

       var prcTotal = prcTotal = (currTotal / 100).toLocaleString(currencyFormat, localeStringParam);

       $(".bundle-total").text(prcTotal);
       if(currTotal == 0){
           $(".product__prices").hide();
           }else{
            $(".product__prices").show();
        }

         $(".bundle-total").text(prcTotal);
    }
    if ($(".digital-memb")[0]){
        if ($('input.digital-memb').is(':checked')){
            $(".tnc-container").show();
        }else{
            $(".tnc-container,.membership-agreement").hide();
        }
    }
    /*================ Membership page================*/
        $(document).on('click','.membership-signup .button',function(){
         var emailValue=$('.membership-signup .email').val();
         var isAgreementChecked=$("#accept-terms-conditions").is(':checked');
         validateEmail(emailValue,$(this),isAgreementChecked);
        });
        $(document).on('click','.membership-signup-bottom .button',function(){
         var emailValue=$('.membership-signup-bottom .email').val();
         var isAgreementChecked=$("#accept-terms-conditions-last").is(':checked');
         //validateEmail(emailValue,$(this),isAgreementChecked);
        });
        if($('div').hasClass('membership-wrapper')){
            setGridHeight($('.join-the-community .community-block'))
        }
        cartMembershiplacement();
    /*==================CrowdFund Email ==================*/
    // $(document).on('click','.crowdfund-signup',function(e){
    //     e.preventDefault();
    //      var emailValue=$('.crowdfunding-waiting .email').val();
    //      var isAgreementChecked=true;
    //      validateEmail(emailValue,$(this),isAgreementChecked);
    //     });
    /*=================Global Header====================*/
    $('.header__secondary-nav .nav-dropdown--first .nav-dropdown__item:last-child a').addClass('logout_btn').addClass('cta-with-arrow');
    $('.js-cart-agree-copy > a, .js-cart-prompt-agree-copy > a, .terms-conditions-disclaimer > a').addClass('redirection-link');
    /*var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
    }*/
    $(document).on("click", ".js-mini-cart-continue",function(e){e.preventDefault();$( "body" ).trigger( "click" );})
    /*=================Tealium implementation====================*/
    var cust_status = $("#cust_login_status").val();
    var logged_status,platform;
    if(cust_status == "true"){
        logged_status = "registered";
    }else{
        logged_status = "anonymous"
    }
    if(/mobile/i.test(navigator.userAgent) == true){
      platform="mobile";
       }
       else if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) != true){
      platform="desktop";
       }
       else{
      platform="tablet";
       }
    //utag_data['platform']= platform;
    $(".header__main-nav ul li a").on("click",function(){
        if($(this).closest(".nav-dropdown").length <= 0)
       {
            var lbl = $(this).text().trim();
            //triggerTags("navigation","click",lbl,"","","",logged_status)
       }
    });
    $(".sidebar-nav ul li a").on("click",function(event){
      var lbl = $(this).text().trim();
      if($(this).hasClass('sidebar-nav__link--level-2')){
       var parent=$(this).closest('.sidebar-nav__sub-links').closest('li').find('.sidebar-nav__link--level-1').text().trim();
      // triggerTags("navigation","click",parent+" | "+lbl,"","","",logged_status);
      }
      else if($(this).hasClass('sidebar-nav__link--level-3')){
       var parent2=$(this).closest('.sidebar-nav__sub-links').closest('li').find('.sidebar-nav__link--level-2').text().trim();
       var parent1=$(this).closest('.sidebar-nav__sub-links').closest('li').find('.sidebar-nav__link--level-2').closest('.sidebar-nav__sub-links').closest('li').find('.sidebar-nav__link--level-1').text().trim();
      // triggerTags("navigation","click",parent1+" | "+parent2+" | "+lbl,"","","",logged_status);
      }
      else{
       //triggerTags("navigation","click",lbl,"","","",logged_status);
      }
      event.stopImmediatePropagation();
    });
    $(".header__main-nav .nav-dropdown .nav-dropdown__item a").on("click",function(){
      var lbl = $(this).text().trim();
      if($(this).hasClass('link')){
        var parent1=$(this).closest('.nav-dropdown').closest('.nav-dropdown__item').parent('li').closest('.header__link').find('a.link:first').text().trim();
        var parent2=$(this).closest('.nav-dropdown').closest('.nav-dropdown__item').find('.nav-dropdown__link:first').text().trim();
       // triggerTags("navigation","click",parent1+" | "+parent2+" | "+lbl,"","","",logged_status)
      }
      else{
          var parent=$(this).closest('.nav-dropdown__item').parent('li').closest('.header__link').find('a.link:first').text().trim();
        //triggerTags("navigation","click",parent+" | "+lbl,"","","",logged_status)
      }
    });
    $(".header__secondary-nav ul .account-info a").on("click",function(){
        if($(this).closest(".nav-dropdown").length <= 0)
       {
            var lbl = $(this).text().trim();
             if(lbl==''){
                lbl="My Account";
             }
            //triggerTags("navigation","click",lbl,"","","",logged_status)
       }
    });
    $(".header__secondary-nav .nav-dropdown .nav-dropdown__item a").on("click",function(){
        var lbl = $(this).text().trim();
        var signinText=$(this).closest('.nav-dropdown').closest('.header__link').find('a.account').text().trim();
        if(logged_status == "registered"){
        //    triggerTags("navigation","click", "My Account | "+lbl,"","","",logged_status)
        }else{
            //triggerTags("navigation","click", signinText+" | "+lbl,"","","",logged_status)
        }
    });
    $(".header__secondary-nav ul li .header__cart-count-wrapper a").on("click",function(){
        //triggerTags("navigation","click", page_id+"_cart button","","","",logged_status)
    });
    $(".announcement-bar a").on("click",function(){
        var linkText = $(this).text();
        var lbl = $(".announcement-text").text().trim().replace(linkText, "");
        //triggerTags("announcement bar","click", page_id+"_"+lbl+"_learn more_announcement bar","","","",logged_status)
    });
    $(".footer__links li a").on("click",function(){
        var lbl = $(this).text().trim();
    //    triggerTags("footer","click", page_id+"_"+lbl+"_footer","","","",logged_status)
    });
    $("#shopify-section-list-collections-template .collection-item").on("click",function(){
        var lbl = $(this).find(".collection-item__title").text().trim();
        //triggerTags("collections","click", page_id+"_"+lbl,"","","",logged_status)
    });
    $(".product-item").on("click",function(){
        var prodSKU = $(this).find(".item_sku").val();
        var lbl = $(this).find(".product-item__title").text().trim();
        var prodPrice = $(this).find(".product-item__price").text().trim();
        var itemPosition = $(this).index();
        //utag.link({event_category:"ecommerce", event_action:"product impression click", event_label: page_id+"_"+lbl+"-"+prodSKU+"_"+itemPosition, product_id:["'"+prodSKU+"'"], product_sku: ["'"+prodSKU+"'"], product_name: ["'"+lbl+"'"], product_unit_price: ["'"+prodPrice+"'"], product_size: ["'"+$(this).variant_inventorysize+"'"]});
    });
    $(".box-announcement .announcement_button").on("click",function(){
        var lbl = $(this).find(".product-item__title").text().trim();
        var itemCategory = $(this).siblings('.h3').text().trim();
        var itemPosition = $(this).index();
        //triggerTags("home","click", page_id+"_"+itemCategory+"_"+lbl+"_b spot #"+itemPosition,"","","",logged_status)
    });
    $(".container-newreleases .grid__cell").on("click",function(){
        var collName = $(this).find(".text-wrapper-position>h6").text().trim();
        var prodName =$(this).find(".text-wrapper-position .promotion__subtitle").text().trim();
        var itemPosition = $(this).index();
        //triggerTags("home","click", page_id+"_"+collName+"_"+prodName+"_new releases #"+itemPosition,"","","",logged_status)
    });
    $(".template-index .shop-now-btn").on("click",function(){
        var prodName =$("#prodTitle").val();
        //triggerTags("home","click", page_id+"_"+prodName+"_shop now_hero module","","","",logged_status)
    });
    $(".template-index .learn-more").on("click",function(){
        var lbl = $(this).text().trim();
        //triggerTags("home","click", page_id+"_learn more_countdown hero","","","",logged_status)
    });
    $(".template-index .plp-button").on("click",function(){
        var lbl = $(this).text().trim();
        //triggerTags("home","click", page_id+"_"+lbl+"_countdown hero","","","",logged_status)
    });
    $(".become-member.non-hero-module .button--primary").on("click",function(){
        var lbl = $(this).text().trim();
        //triggerTags("home","click", page_id+"_"+lbl+"_membership","","","",logged_status)
    });
    $(".membership-signup .button--primary").on("click",function(){
        //triggerTags("membership","click", page_id+"_enter your email_get started_get access to exclusive member only_enter your email_get started","","","",logged_status)
    });
    $(".membership-signup-bottom .button--primary").on("click",function(){
        //triggerTags("membership","click", page_id+"_ready to join?_enter your email_get started","","","",logged_status)
    });
    $(".disclaimer .disclaimer_link").on("click",function(){
        var lbl = $(this).text().trim();
        //triggerTags("membership","click", page_id+"_"+lbl+"_membership","","","",logged_status)
    });
    $(".customer__addresses-link").on("click",function(){
        var lbl = $(this).text().trim();
        //triggerTags("account summary","click", page_id+"_"+lbl+"_account summary","","","",logged_status)
    });
    $(".customer-order-link").on("click",function(){
        var lbl = $(this).text().trim();
        //triggerTags("account summary","click", page_id+"_"+lbl+"_order summary","","","",logged_status)
    });
    $("#address_form_new .button--primary,.edit-cust-address .button--primary").on("click",function(){
        var lbl = $(this).val();
        //triggerTags("account summary","click", page_id+"_"+lbl+"_button","","","",logged_status)
    });
  $(".product-item__link").on("click",function(){
        var prodTitle = $(this).find("#productTitle").val();
        var productSKU = $(this).find("#prodSku").val();
        var prodVendor=$(this).find("#productVendor").val();
        var prodprice=$(this).find("#product-price").val();
        var prodId=$(this).find("#productId").val();
        var prodCat=$(this).find("#productCategory").val();
        var discount=$(this).find("#discount-amount").val();
        var originalPrice=$(this).find(".originalprice").val();
        var listName=$(this).find('#listName').val();
        var prodIndex=$(this).index();
      gtagSelectitem(
        prodTitle,
        productSKU,
        prodVendor,
        prodprice,
        prodId,
        prodCat,
        discount,
        originalPrice,
        prodIndex,
        listName,
      );
  });
  $(".js-product-add-on-link").on("click",function(){
      var prodTitle = $(this).attr('data-name');
      var productSKU = $(this).attr('data-sku');
      var prodVendor= $(this).attr('data-vendor');
      var prodprice = $(this).attr('data-price');
      var prodId = $(this).attr('data-id');
      var prodCat = $(this).attr('data-category');
      var discount = $(this).attr('data-discount');
      var originalPrice = $(this).attr('data-original-price');
      var listName = $(this).attr('data-name');
      var prodIndex = $(this).attr('data-index');
      var ageGrade = $(this).attr('data-age');
      var badge = $(this).attr('data-badge') || undefined;
      var prodCat2 = $(this).attr('data-category-2') || undefined;
      var variantId = $(this).attr('data-variant');
      var couponText = $(this).attr('data-coupon');
      gtagSelectitem(
        prodTitle,
        productSKU,
        prodVendor,
        prodprice,
        prodId,
        prodCat,
        discount,
        originalPrice,
        prodIndex,
        'Add-On Product',
        ageGrade,
        badge,
        prodCat2,
        '1',
        variantId,
        couponText,
      );
  });
    $(".js-cart-checkout").on("click",function(e){
        var lbl = $(this).text().trim();
        //utag.link({event_category:"ecommerce", event_action:"checkout", event_label: page_id+"_"+lbl, checkout_step: 1, product_sku: utag_data.product_sku, product_quantity: utag_data.product_quantity, product_name: utag_data.product_name, product_unit_price: utag_data.product_price,product_pricing_indicator: utag_data.site_currency, logged_in_status: logged_status});
        // triggerTags("ecommerce","checkout", page_id+"_"+lbl,"","","")
    });
    $(".js-cart-continue-shopping").on("click",function(){
        var lbl = $(this).text().trim();
        //utag.link({event_category:"ecommerce", event_action:"click", event_label: page_id+"_"+lbl, logged_in_status: logged_status});
         //triggerTags("ecommerce","click", page_id+"_"+lbl,"","","")
    });
    $('.clickable-dd').on('change', function() {
        const { trackingCategory, trackingText } = this.options[this.selectedIndex]?.dataset;

        if (trackingCategory && trackingText) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'navigation',
            category: trackingCategory || '',
            link_text: trackingText || '',
          });
        }

        window.location.href = this.value;
    });
    $(document).on("click", "#btnGenerateLabel", function(){
        ReturnLabelJS.processFedExForm();
        return false;
    });
    $('.header__main-nav a,.sidebar-nav__links a').each(function(){
        if($(this).text().toLowerCase()=="news" || $(this).text().toLowerCase()=="community"){
            $(this).removeAttr("target").removeAttr("rel");
        }
    });
    $('.container-newreleases a').each(function(){
        $(this).removeAttr("target").removeAttr("rel");
    });
    /* Tealium implementation for Signup Modal*/
    $(".signup-modal-open").on("click",function(){
        //utag.link({event_name:"modal_view",page_id:"mc:us:shop:home", cta_category:"email_signup" , cta_action:"view" });
    });
    $(".signup-modal-check-brand").on("click",function(){
        var chkbox_state=$(this).prop("checked") == true ? "checkbox:uncheck" : "checkbox:check";
        //utag.link({event_name:"modal_click",page_id:"mc:us:shop:home", cta_category:"email_signup" , cta_action:chkbox_state,cta_detail:$(this).val() });
    });
    $(".signup-modal-check-subscribe").on("click",function(){
        var chkbox_state=$(this).prop("checked") == true ? "checkbox:check" : "checkbox:uncheck";
        //utag.link({event_name:"modal_click",page_id:"mc:us:shop:home", cta_category:"email_signup" , cta_action:chkbox_state,cta_detail:"subscribe" });
    });
    $(".signup-modal-button").on("click",function(){
        var brandNamelist = [];
        $.each($(".signup-modal-check-brand:checked"), function(){
            brandNamelist.push($(this).val());
        });
        //utag.link({event_name:"modal_click",page_id:$(this).attr('data-pid'), cta_category:"email_signup" , cta_action:"buttonClick",cta_detail:"signup",cta_subDetail:brandNamelist });
    });
    $(".signup-modal-notinterested").on("click",function(){
        var brandNamelist = [];
        $.each($(".signup-modal-check-brand:checked"), function(){
            brandNamelist.push($(this).val());
        });
        //utag.link({event_name:"modal_click",page_id:$(this).attr('data-pid'), cta_category:"email_signup" , cta_action:"linkClick",cta_detail:"nm, I don't want to signup",cta_subDetail:brandNamelist });
    });
    var hoverElement;
    /* Global Button hover */
    $('.button').hover(function(){

        if(hoverElement==$(this).attr('class')){
            return;
        }
        else{
            $('.button').removeClass('white-bg-cta').removeClass('black-bg-cta').removeClass('grey-bg-cta').removeClass('white-outline-cta');
             if($(this).css('background-color')=="rgb(0, 0, 0)" && $(this).css('border-width')!="0px" && $(this).css('border-color')=="rgb(255, 255, 255)"){
                $(this).addClass('white-outline-cta');
            }
            else if($(this).css('background-color')=="rgb(255, 255, 255)"){
                $(this).addClass('white-bg-cta');
            }
            else if($(this).css('background-color')=="rgb(0, 0, 0)" || $(this).css('background-color')=="rgb(12, 12, 13)" ){
                $(this).addClass('black-bg-cta');
            }
            else if($(this).css('background-color')=="rgb(221, 221, 221)"){
                $(this).addClass('grey-bg-cta');
            }
            hoverElement=$(this).attr('class');
        }

    });
    $('.cta-with-arrow').hover(function(){
        $('.cta-with-arrow').removeClass('white-arrow-cta').removeClass('black-arrow-cta');
        if($(this).css('color')=="rgb(255, 255, 255)"){
            $(this).addClass('white-arrow-cta');
        }
        else if($(this).css('color')=="rgb(0, 0, 0)"){
            $(this).addClass('black-arrow-cta');
        }
    });
    $('a.redirection-link').hover(function(){
        $('a').removeClass('white-text-link').removeClass('black-text-link');
        if($(this).css('color')=="rgb(255, 255, 255)"){
            $(this).addClass('white-text-link');
        }
        else if($(this).css('color')=="rgb(0, 0, 0)"){
            $(this).addClass('black-text-link');
        }
        else{
            $(this).addClass('black-text-link');
        }
    });

    /* Past Products slider */
/*    if($('.products-grid').length){
      $('.products-grid').slick({
          accessibility: false,
          dots: true,
          dotsClass: 'slider-dots',
          arrows: false,
          adaptiveHeight: true,
          mobileFirst: true,
          infinite: false,
          centerMode: true,
          centerPadding: '32px',
          slidesToShow: 1,
          responsive: [
            {
              breakpoint: 560,
              settings: 'unslick'
            }
          ]
        });
    }*/
    /* Adding class name based on main nav child length*/
    $('.header__main-nav .header__link--need-extra-space').each(function(){
      if($(this).find('.nav-dropdown--second').length > 0){
              $(this).addClass('multi-level-menu');
      }
      else if(!$(this).find('.nav-dropdown--shop-featured').length){
              $(this).addClass('single-level-menu');
      }
    });
    if($('.header__main-nav .header__link--need-extra-space.multi-level-menu')[0]){
        setMenuheightDynamic();
    }
    function showContactAlert(type) {
      var $successMessage = $('#contact-success-message');
      var $errorMessage = $('#contact-error-message');

      if (type === 'success') {
        $errorMessage.addClass('hide');
        $successMessage.removeClass('hide');
        return;
      }

      $successMessage.addClass('hide');
      $errorMessage.removeClass('hide');
    }

    function hideContactAlerts() {
      $('#contact-success-message, #contact-error-message').addClass('hide');
    }

    function resetContactAttachments($form) {
      var $attachmentError = $form.find('#contact-attachments-error');
      $attachmentError.empty();

      $form.find('.contact-form-slot-input').each(function() {
        var $slot = $(this).closest('.form-attachment__slot');
        var $thumbImg = $slot.find('.form-attachment__item-thumb-img');

        if ($thumbImg.attr('src') && $thumbImg.attr('src').indexOf('blob:') === 0) {
          URL.revokeObjectURL($thumbImg.attr('src'));
        }

        this.value = '';
        $thumbImg.attr('src', '').attr('hidden', '');
        $slot.find('.form-attachment__item-thumb-placeholder').show();
        $slot.find('.form-attachment__item-name').text('');
        $slot.attr('hidden', '');
      });
    }

    function resetContactFormState($form) {
      $form[0].reset();
      $form.find('.error-wrap').empty();
      $form.find('.recaptcha-error-wrap').empty();
      $form.find('.form__input, .form__textarea').css('border', '1px solid #231F20');
      resetContactAttachments($form);

      var $topic = $form.find('#topic');
      if ($topic.length) {
        $topic.prop('selectedIndex', 0).trigger('change');
      }

      var $preferredLanguage = $form.find('#preferredLanguage');
      if ($preferredLanguage.length) {
        $preferredLanguage.prop('selectedIndex', 0).trigger('change');
      }

      $(".prod_name,.purch_date,.ord_number").hide().find('fieldset').attr('disabled','true');

      const reCaptchaEl = document.querySelector('.g-recaptcha div');
      if (reCaptchaEl) {
        reCaptchaEl.style.border = 'none';
      }
    }

    $('#contact_form').on('submit', async function(event){
    event.preventDefault();
    var $form = $(this);
    var $submitButton = $form.find('.cs-contact-button');
    var form_data= $form.serializeArray();
      var form_error =0,errordescription='',errorfield='';
    hideContactAlerts();
    localStorage.setItem('contact_page_form_data', JSON.stringify(form_data));
    for (var input in form_data){
      var element=$("[name='"+form_data[input]['name']+"']");
        if (!element[0]) { continue; }
        if (element[0].type === 'hidden' || element[0].disabled) { continue; }
        if ($(element[0]).closest('.form__control').length && $(element[0]).closest('.form__control').css('display') === 'none') { continue; }
        if($(element[0]).val() == '' && $(element[0]).attr('name') != 'email'){
            $(element[0]).siblings('.error-wrap').find('.error-text').remove();
            $(element[0]).parent().find('.error-wrap').append("<p class='error-text'>This field is required</p>");
            $(element[0]).css('border','1px solid #ee0024');
            form_error++;
            // gtagformError($(element[0]).attr('data-field'),"This field is required");
          form_error == 1 ? errordescription+=$(element[0]).attr('data-field')+" field is required" : errordescription+=", "+$(element[0]).attr('data-field')+" field is required" ;
          form_error == 1 ? errorfield+=$(element[0]).attr('data-field') : errorfield+=', '+$(element[0]).attr('data-field');

        }else if($(element[0]).attr('name') === 'email'){
            var re = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
            var is_email=re.test($('#email').val());
            if($('#email').val() == ''){
                $('.emailerr').remove();
                $('#email').parent().find('.error-wrap').append("<p class='error-text emailerr'>This field is required</p>");
                $('#email').css('border','1px solid #ee0024');
                form_error++;
                //gtagformError($(element[0]).attr('placeholder'),"This field is required");
                form_error == 1 ? errordescription+="Email field is required" : errordescription+=", Email field is required";
              form_error == 1 ? errorfield+=$(element[0]).attr('placeholder') : errorfield+=','+$(element[0]).attr('placeholder');
            }else if(!is_email){
                $('.emailerr').remove();
                $('#email').parent().find('.error-wrap').append("<p class='error-text emailerr'>Invalid email address</p>");
                $('#email').css('border','1px solid #ee0024');
                form_error++;
                //gtagformError($(element[0]).attr('placeholder'),"Invalid email address");
                form_error == 1 ? errordescription+="Invalid email address" : errordescription+=", Invalid email address";
                form_error == 1 ? errorfield+=$(element[0]).attr('placeholder') : errorfield+=','+$(element[0]).attr('placeholder');
            }else{
                $(element[0]).css('border','1px solid #231F20');
                if ($(element[0]).parent().find('.error-wrap').html() !== ''){
                  $(element[0]).parent().find('.error-wrap').html('');
                }
            }
        }else{
          $(element[0]).css('border','1px solid #231F20');
          $(element[0]).siblings('.error-wrap').find('.error-text').remove();
        }
    }
      const errorWrap = $form.find('.recaptcha-error-wrap');
      const reCaptchaEl = document.querySelector('.g-recaptcha div');
      if (!reCaptchaResponseToken) {
        errorWrap.html('');
        errorWrap.append("<p class='error-text emailerr'>This field is required</p>")
        if (reCaptchaEl) reCaptchaEl.style.border = '1px solid #ee0024';
        form_error++;
      } else {
        errorWrap.html('');
        if (reCaptchaEl) reCaptchaEl.style.border = 'none';
      }
      if (form_error === 0 && $form.attr('id') === 'contact_form') {
        var contactAttachmentsError = false;
        var $attErr = $form.find('#contact-attachments-error');
        $attErr.empty();
        var maxFiles = 5;
        var maxFileSize = 25 * 1024 * 1024;
        var maxTotalSize = 125 * 1024 * 1024;
        var allowedExt = ['jpg','jpeg','png'];
        var fileCount = 0;
        var totalSize = 0;
        $form.find('input[type="file"][name="attachment"].contact-attachment-field').each(function() {
          var inp = this;
          if (inp.files && inp.files.length) {
            var file = inp.files[0];
            fileCount++;
            totalSize += file.size;
            var ext = file.name.split('.').pop().toLowerCase();
            if (allowedExt.indexOf(ext) === -1) {
              $attErr.append("<p class='error-text'>File type not supported. Please use JPG, JPEG, or PNG.</p>");
              contactAttachmentsError = true;
              return false;
            }
            if (file.size > maxFileSize) {
              $attErr.append("<p class='error-text'>Each file must be 25 MB or smaller.</p>");
              contactAttachmentsError = true;
              return false;
            }
          }
        });
        if (!contactAttachmentsError && fileCount > maxFiles) {
          $attErr.append("<p class='error-text'>Maximum 5 files allowed.</p>");
          contactAttachmentsError = true;
        }
        if (!contactAttachmentsError && totalSize > maxTotalSize) {
          $attErr.append("<p class='error-text'>Total upload size exceeds 125 MB.</p>");
          contactAttachmentsError = true;
        }
        if (contactAttachmentsError) {
          form_error++;
        }
      }
      if(form_error == 0 ){
        $submitButton.prop('disabled', true);
        try {
          const response = await fetch($form.attr('action'), {
            method: 'POST',
            body: new FormData($form[0]),
            credentials: 'same-origin'
          });

          if (!response.ok) {
            showContactAlert('error');
            return;
          }

          localStorage.removeItem('contact_page_form_data');
          showContactAlert('success');
          resetContactFormState($form);
          if (typeof grecaptcha !== 'undefined') {
            grecaptcha.reset();
          }
          reCaptchaResponseToken = null;
          const successMessage = document.getElementById('contact-success-message');
          if (successMessage) {
            successMessage.focus();
          }
          const topicField = form_data.find((input) => input.name === 'topic');
          gtagformSubmit(topicField?.value, 'contact us');
        } catch (submitError) {
          showContactAlert('error');
        } finally {
          $submitButton.prop('disabled', false);
        }
      }
      else{
          event.preventDefault();
          gtagformError( errorfield,errordescription);
      }
    });
    var contactAttachmentMax = 5;
    function getContactFilledAttachmentCount() {
      var n = 0;
      $('#contact_form .contact-form-slot-input').each(function() {
        if (this.files && this.files.length) {
          n += 1;
        }
      });
      return n;
    }
    $(document).on('click', '#contact-upload-btn', function() {
      var $err = $('#contact-attachments-error');
      if (getContactFilledAttachmentCount() >= contactAttachmentMax) {
        $err.empty();
        $err.append("<p class='error-text'>Maximum 5 files allowed.</p>");
        return;
      }
      $err.empty();
      var $next = $('#contact_form .contact-form-slot-input').filter(function() {
        return !this.files || !this.files.length;
      }).first();
      if ($next.length) {
        $next.trigger('click');
      }
    });
    $(document).on('change', '.contact-form-slot-input', function() {
      var inp = this;
      if (!inp.files || !inp.files[0]) {
        return;
      }
      var file = inp.files[0];
      var $err = $('#contact-attachments-error');
      $err.empty();
      var ext = file.name.split('.').pop().toLowerCase();
      var allowedExt = ['jpg', 'jpeg', 'png'];
      if (allowedExt.indexOf(ext) === -1) {
        $err.append("<p class='error-text'>File type not supported. Please use JPG, JPEG, or PNG.</p>");
        inp.value = '';
        return;
      }
      var maxFileSize = 25 * 1024 * 1024;
      if (file.size > maxFileSize) {
        $err.append("<p class='error-text'>Each file must be 25 MB or smaller.</p>");
        inp.value = '';
        return;
      }
      var totalSize = file.size;
      $('#contact_form .contact-form-slot-input').each(function() {
        if (this !== inp && this.files && this.files[0]) {
          totalSize += this.files[0].size;
        }
      });
      var maxTotalSize = 125 * 1024 * 1024;
      if (totalSize > maxTotalSize) {
        $err.append("<p class='error-text'>Total upload size exceeds 125 MB.</p>");
        inp.value = '';
        return;
      }
      var $slot = $(inp).closest('.form-attachment__slot');
      var $item = $slot.find('.form-attachment__item');
      var $thumbImg = $item.find('.form-attachment__item-thumb-img');
      var $ph = $item.find('.form-attachment__item-thumb-placeholder');
      $item.find('.form-attachment__item-name').text(file.name);
      if (file.type && file.type.indexOf('image/') === 0) {
        if ($thumbImg.attr('src') && $thumbImg.attr('src').indexOf('blob:') === 0) {
          URL.revokeObjectURL($thumbImg.attr('src'));
        }
        $thumbImg.attr('src', URL.createObjectURL(file)).removeAttr('hidden');
        $ph.hide();
      } else {
        $thumbImg.attr('src', '').attr('hidden', '');
        $ph.show();
      }
      $slot.removeAttr('hidden');
    });
    $(document).on('click', '.form-attachment__item-remove', function(e) {
      e.preventDefault();
      var slotNum = $(this).data('slot');
      var inp = document.getElementById('contact_attachment_' + slotNum);
      if (!inp) {
        return;
      }
      var $slot = $(inp).closest('.form-attachment__slot');
      var $thumbImg = $slot.find('.form-attachment__item-thumb-img');
      if ($thumbImg.attr('src') && $thumbImg.attr('src').indexOf('blob:') === 0) {
        URL.revokeObjectURL($thumbImg.attr('src'));
      }
      $thumbImg.attr('src', '').attr('hidden', '');
      $slot.find('.form-attachment__item-thumb-placeholder').show();
      $slot.find('.form-attachment__item-name').text('');
      inp.value = '';
      $slot.attr('hidden', '');
    });

    if( $('.template-page-contact')[0]){
          const contactParams = new URLSearchParams(window.location.search);
          if(contactParams.get('form_posted') === 'true') {
            localStorage.removeItem('contact_page_form_data');
            $('#contact-success-message').removeClass('hide');
            const successMessage = document.getElementById('contact-success-message');
            if (successMessage) {
              successMessage.focus();
            }
          }
          else if(contactParams.get('form_posted') === 'false'){
            $('#contact-error-message').removeClass('hide');
            storedData = localStorage.getItem('contact_page_form_data');
            setFormInput(storedData);
          }
    }

    function setFormInput(unparsedData) {
      if (!unparsedData) return;
      var data = JSON.parse(unparsedData);
      var $contactForm = document.getElementById('contact_form');
      if ($contactForm) {
        data.forEach((item) => {
          const $domElement = $contactForm.querySelector('[name="' + item.name + '"]');
          if ($domElement) {
            $domElement.value = item.value;
          }
        });
      }
    }

    $('#topic').on('change', function (e) {
        var valueSelectedIndex = $(this).prop('selectedIndex');
        if(valueSelectedIndex == 2){
            $(".ord_number,.purch_date").show().find('fieldset').removeAttr('disabled');
            $(".prod_name").hide().find('fieldset').attr('disabled','true');
        }else if(valueSelectedIndex == 5 || valueSelectedIndex == 9 || valueSelectedIndex == 4){
            $(".prod_name,.purch_date,.ord_number").show().find('fieldset').removeAttr('disabled');
        }else{
            $(".prod_name,.purch_date,.ord_number").hide().find('fieldset').attr('disabled','true');
        }
    });

    if(location.href.indexOf('#contact_form') > 0){
        // $('html, body').animate({
        //      scrollTop: $("#contact_form").offset().top - 80
        // }, 1000);
    }
     /*Order status form validation */
    $('#order__tracking__button').on('click',function(e){
      var form_error =0,errordescription='',errorfield='';;
        var errors = false;
       $(".order_email_error,.order_number_error").css('display','none');
       $('#order__number,#order__email').css('border','1px solid #231F20');
       var orderNumber = $('#order__number').val();
       var orderEmail = $('#order__email').val();
       var orderApi=$('#orderapilink').val();
       var emailValidation = false,numberValidation = false;
         var emailRegex=/^([a-zA-Z]+[a-zA-Z0-9_\-\+\.]+)@((([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if(orderEmail==""){
                $(".order_email_error").addClass('active').stop().delay(500).queue('',function(){
                    $(this).removeClass('active');
                });
                $(".order_email_error").html($('#order__email').data('empty'));
                $(".order_email_error").css('display','block');
                $('#order__email').css('border','1px solid #EE0024');
                //gtagformError_order("Email Address",$('#order__email').data('empty'));
                form_error++;
                errordescription+=$('#order__email').data('empty');
                errorfield+="Email Address";
        }
        else if(!emailRegex.test(orderEmail)){
                $(".order_email_error").addClass('active').stop().delay(500).queue('',function(){
                    $(this).removeClass('active');
                });
                $(".order_email_error").html($('#order__email').data('error'));
                $(".order_email_error").css('display','block');
                   $('#order__email').css('border','1px solid #EE0024');
                //gtagformError_order("Email Address",$('#order__email').data('error'));
                form_error++;
                errordescription+=$('#order__email').data('error');
                errorfield+="Email Address";
        }

        else{
            emailValidation=true;
        }
        var numberRegex =/^[A-Za-z0-9]+$/;
        if(orderNumber==""){
                $(".order_number_error").addClass('active').stop().delay(500).queue('',function(){
                    $(this).removeClass('active');
                });
                $(".order_number_error").html($('#order__number').data('empty'));
                  $(".order_number_error").css('display','block');
                   $('#order__number').css('border','1px solid #EE0024');
                //gtagformError_order("Order Number",$('#order__number').data('empty'));
                form_error++;
                  form_error ==1 ? errordescription+=$('#order__number').data('empty') : errordescription+=', '+$('#order__number').data('empty');
                  form_error ==1 ? errorfield+="Order Number" : errorfield+=", Order Number";
        }
        else if(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/.test(orderNumber) == false ){
                $(".order_number_error").addClass('active').stop().delay(500).queue('',function(){
                    $(this).removeClass('active');
                });
                $(".order_number_error").html($('#order__number').data('error'));
                $(".order_number_error").css('display','block');
                $('#order__number').css('border','1px solid #EE0024');
                //gtagformError_order("Order Number",$('#order__number').data('error'));
                  form_error ==1 ? errordescription+=$('#order__number').data('error') : errordescription+=', '+$('#order__number').data('error');
                  form_error ==1 ? errorfield+="Order Number" : errorfield+=", Order Number" ;
        }
        else{
            numberValidation=true;
        }
      if(numberValidation==true && emailValidation==true){
          var orders = {'number':orderNumber,'email':orderEmail};
          var jsonValue={message:orders}
          var orderDetails=JSON.stringify(jsonValue);

          var settings = {
          //"url": "https://api-dtc-test.platform.mattel/v1/ch/order/search",
          "url":orderApi,
          "method": "POST",
          "timeout": 0,
          "headers": {
          "Content-Type": "text/plain"
          },
            "data": orderDetails,
          };
          $.ajax(settings).done(function (response) {
            if(response == "Could not find order url" || response =="order name provided from wrong store"){
                $(".order_number_error").html($('#order__number').data('error'));
                $(".order_number_error").css('display','block');
                $('#order__number').css('border','1px solid #EE0024');
                gtagformError_order("Order Number",$('#order__number').data('error'));
            }
            else if(response == "email provided does not match order"){
                $(".order_email_error").html($('#order__email').data('error'));
                $(".order_email_error").css('display','block');
                  $('#order__email').css('border','1px solid #EE0024');
                gtagformError_order("Email Address",$('#order__email').data('error'));
            }
            else{
                window.location.href=response;
                 gtagformSubmit_order('content_area','Order Status');
            }
          });
          $.ajax(settings).fail(function(xhr) {
            if(xhr.responseText == "order name provided from wrong store"){
                $(".order_number_error").html($('#order__number').data('error'));
                $(".order_number_error").css('display','block');
                $('#order__number').css('border','1px solid #EE0024');
                gtagformError_order("Order Number",$('#order__number').data('error'));
            }
          });
      }
      else{
          gtagformError_order(errorfield,errordescription);
      }
    })
    /* PDP soldout : activate email signup  */
    if($('.template-product')[0]){
        if($('#preorderSoldout').length>0){
            $('.soldout-badge').remove();
        }
        if($('#soldoutActive').length>0){
          $('.pdp-soldout').removeClass('hide');
        } else if (!SDG.Data.isCrowdfund) {
          $('.pdp-soldout').addClass('hide');
        }
        $('.pdp-soldout').insertAfter('.product__details form');
        errorHandling();
    }
  /* Globale welcome mat & country dropdown updates */
     globaleWelcome();
     globaleDrop();

  if($('.collabs-page__cta-main')[0]){
    $(".collabs-page__cta-main").addClass("button button--primary black-bg-cta");
    $('.collabs-page__cta-login-link').appendTo('.collabs-page__cta-login-section p');
  }

});

/*This add to cart function only work with the single or multiple product-add with checkbox,
 single product-add without checkbox is handled by script.js*/
const productDataAfterAdd = [];

function getSelectedPdpGwpVariantId() {
  const $productGwp = document.querySelector('.js-product-gwp');
  if (!$productGwp || $productGwp.classList.contains('product-gwp--disabled')) return null;

  const $checked = $productGwp.querySelector('.js-product-gwp-input:checked:not(:disabled)');
  return $checked ? $checked.value : null;
}

function addAllItems(array, quantity , mainProduct, otherProductProperties){
    const {
      rlcAccessSellingPlan = false,
      exclusiveBrand = false,
      exclusiveMembershipIds = {},
      bagItems = [],
    } = SDG?.Data;

    Shopify.queue = [];
      var newArray = array?.length > 0 ? array.split(',') : [];
      var digitalMembUpsellId = document.querySelector('.upsell-products.digital-memb')?.id;

      for (var i = 0; i < newArray.length; i++) {
        product = newArray[i];

        // Skip empty or undefined product IDs
        if (!product || product === '' || product === 'undefined') {
          continue;
        }

        const isProductDigitalMembership = Object.values(exclusiveMembershipIds).some(
          (id) => String(id) === String(product),
        )
          || otherProductProperties[i]?._is_digital_membership === 'true'
          || otherProductProperties[i]?._is_digital_membership === true
          || (digitalMembUpsellId && String(product) === String(digitalMembUpsellId));

        // Digital membership is always qty 1 — never use the PDP qty selector
        const lineQuantity = isProductDigitalMembership ? 1 : mainProduct.quantity;

        // Skip re-adding membership if one is already in the cart (limit 1)
        if (isProductDigitalMembership) {
          const membershipAlreadyInCart = bagItems.some((item) =>
            Number(item.variant_id) === Number(product)
          );
          if (membershipAlreadyInCart) {
            continue;
          }
        }

        // Handle mixed cart validation for UK
        if (SDG.Data.isUk) {
          const preOrderInCart = bagItems.find(
            (item) => {
              if (item.properties) {
                return item.properties._is_preorder === 'true';
              }
              if (item.full_data) {
                return item.full_data?.properties?._is_preorder === 'true';
              }
              return false;
            }
          );

          if (preOrderInCart && !isProductDigitalMembership && !isSameProductInCart) {
            SDG.Data.mixedCartModalUk.open();
            return;
          }
        }

        const isRestrictedInCart = bagItems.find(
          (item) => {
            if (item?.properties) {
              return item.properties?._restricted_cart === 'true';
            }
            if (item?.full_data) {
              return item.full_data?.properties?._restricted_cart === 'true';
            }
            return false;
          }
        );

        if (isProductDigitalMembership && isRestrictedInCart) {
          SDG.Data.mixedCartModal.open();
          return;
        }

        if (product === mainProduct.id && !mainProduct.isMembershipPdp) {
          // Skip adding the main product for now
          continue;
        }

        let properties = {};

        if (product === mainProduct.id) {
          const existingCartItem = bagItems.find(item => item.variant_id === Number(product));
          if (existingCartItem && !mainProduct.properties._item_list_type) {
            // Use existing properties from cart to consolidate line items
            const cartProperties = existingCartItem.properties || existingCartItem.full_data?.properties || {};
            // Convert array format to object if needed (existingCartItem.properties)
            if (Array.isArray(cartProperties)) {
              properties = Object.fromEntries(cartProperties);
            } else {
              properties = { ...cartProperties };
            }
          } else {
            properties = {
              ...mainProduct.properties,
              _referrer: 'Standard',
            };
          }
        }

        if (isProductDigitalMembership) {
          properties = {
            ...otherProductProperties[i],
            _is_digital_membership: 'true',
            _agreement_checked: 'true',
            _membership_no_agreement: 'false',
            _upgrade_option: 'upsell',
          };
        }

        Shopify.queue.push({
          variantId: product,
          quantity: lineQuantity,
          properties
        });
      }

      const addOnChecked = document.querySelectorAll('.js-product-add-on-input:checked');
      addOnChecked.forEach((addOn) => {
        Shopify.queue.unshift({
          variantId: addOn.value,
          properties: {
            _reference: SDG.randomId(25),
          }
        });
      });

      const selectedGwpVariantId = getSelectedPdpGwpVariantId();
      if (selectedGwpVariantId) {
        Shopify.queue.push({
          variantId: selectedGwpVariantId,
          quantity: 1,
          properties: {
            _reference: SDG.randomId(25),
            _gwp: 'true',
          },
        });
      }

      // Append the main product to the end of Shopify.queue.
      // This ensures memberships are added to the cart first,
      // as exclusive items cannot be added before a membership.
      if (!mainProduct.isMembershipPdp && mainProduct.id && !mainProduct.isDeselected) {
        const isMainProductDigitalMembership = Object.values(exclusiveMembershipIds).includes(mainProduct.id);

        // Check if the main product already exists in cart
        const existingMainItem = bagItems.find(item => item.variant_id === Number(mainProduct.id));
        let properties = {};

        if (existingMainItem && !mainProduct.properties._item_list_type) {
          // Reuse existing properties to consolidate line items
          const cartProperties = existingMainItem.properties || existingMainItem.full_data?.properties || {};
          if (Array.isArray(cartProperties)) {
            properties = Object.fromEntries(cartProperties);
          } else {
            properties = { ...cartProperties };
          }
        } else {
          properties = {
            ...mainProduct.properties,
            _exclusive_brand: exclusiveBrand,
            _is_digital_membership: isMainProductDigitalMembership
          };
        }

        if (isMainProductDigitalMembership && !existingMainItem) {
          properties._agreement_checked = "true";
          properties._membership_no_agreement = "false";
        }
        Shopify.queue.push({
          variantId: mainProduct.id,
          properties,
          quantity: mainProduct.quantity,
        });
      }

      Shopify.moveAlong = function() {
      // Process all items in Shopify QUE as a single request
      if (Shopify.queue.length) {
        var data = {
          items: Shopify.queue
            .filter((item) => item.variantId && item.variantId !== '' && item.variantId !== 'undefined')
            .map((item) => {
              const { variantId, quantity, properties } = item;
              return {
                id: variantId,
                quantity,
                properties,
              }
            })
        };

        var request = Shopify.queue[0];
        const sellingPlanInput = document.querySelector('[name="selling_plan"]');
        if(request.properties) {
            var object = {};
            object.quantity = request.quantity ? request.quantity : 1;
            object.id = request.variantId;
            object.properties = request.properties;
            if (rlcAccessSellingPlan && request.variantId === rlcAccessSellingPlan.productId) {
              object.selling_plan = rlcAccessSellingPlan.planId
              if (SDG.Data.isPreOrder) {
                data.items[0].selling_plan = rlcAccessSellingPlan.planId;
              }
            }
            if (
              SDG.Data.isUk &&
              sellingPlanInput?.value &&
              !object.properties._is_digital_membership &&
              mainProduct.id === request.variantId
            ) {
              const hasMembershipInCart = bagItems.some((item) =>
                item.full_data?.properties?._is_digital_membership === 'true' ||
                item.properties?._is_digital_membership === 'true'
              );
              const isSameItemInCart = bagItems.some((item) =>
                item.variant_id === Number(request.variantId)
              );
              const hasOtherProductInCart = bagItems.some((item) =>
                item.variant_id !== Number(request.variantId) &&
                item.full_data?.properties?._is_digital_membership !== 'true' &&
                item.properties?._is_digital_membership !== 'true'
              );
              if (hasOtherProductInCart && !hasMembershipInCart && !isSameItemInCart) {
                SDG.Data.mixedCartModalUk.open();
                return;
              }
            }
        }

        const hasPreOrderInCart = SDG.Data.bagItems
          .find((item) => item.full_data?.properties?._is_preorder === 'true' || item.properties?._is_preorder === 'true' || item.selling_plan_allocation);  // eslint-disable-line
        const { isUk } = SDG.Data;
        if (hasPreOrderInCart && isUk) {
          const isMainProductDigitalMembership = Object.values(exclusiveMembershipIds).includes(mainProduct.id);
          if (!isMainProductDigitalMembership && !SDG.Data.isPreOrder) {
            SDG.Data.mixedCartModal.open('modalMixedCart');
            return;
          }
        }

        // Check limits for all items in queue, not just the first one
        const isCombinedListing = $('#combinedListing').length > 0;

        for (const queueItem of Shopify.queue) {
          if (queueItem.variantId === mainProduct.id) {
            const productLimitEl = $("#product_limit");
            var limitBy = productLimitEl.val();

            if (isCombinedListing) {
              const selectedInput = $(`.js-combined-item-input[value="${queueItem.variantId}"]`);
              const childLimitQty = selectedInput.data('limit-quantity');

              if (childLimitQty) {
                limitBy = childLimitQty;
              }
            }

            const totalQtyInCart = SDG.Data.bagItems.reduce((total, item) => {
              if (item.variant_id === Number(queueItem.variantId)) {
                return total + item.quantity;
              }
              return total;
            }, 0);

            if (limitBy && (totalQtyInCart + queueItem.quantity) > Number(limitBy)) {
              $('.product__add-to-cart').attr('disabled', true);
              
              // For combined listings, remove any existing error before adding a new one
              if (isCombinedListing) {
                $(".warning-msg.limited").remove();
              }

              const existingWarning = $(".warning-msg.limited").length;
              if (existingWarning === 0) {
                var errorH = '<p class="warning-msg bold limited" style="display:block"><i class="icon icon--error-exclamation-small"></i> You have reached the limit of '+limitBy+' per order.</p>';
                $(".product__payment-container").parents('#non-rlc-container').prepend(errorH);
                scrollPdpErrorIfVisible($(".warning-msg.limited")[0]);
              } else {
                $(".warning-msg.limited").show().each(function () {
                  scrollPdpErrorIfVisible(this);
                });
                $(".warning-msg.limited").removeClass('hide');
              }

              return;
            }

            break;
          }
        }


        if (SDG.Data.isPodProduct) {
          const previewUrlLineProperty = document.querySelector('.product__slideshow:not(.hide) .product__slide--image');
          if (previewUrlLineProperty) {
            data.items[0].properties._bg_previewUrl = previewUrlLineProperty.dataset.mfpSrc;
          }
          const cldBgPublicId = document.querySelector('input[name="properties[_cld_bg_publicId]"]');
          if (cldBgPublicId) {
            data.items[0].properties._cld_bg_publicId = cldBgPublicId.value;
          }
          data.items[0].properties._combined_listing_url = `/products/${SDG.Data.productHandle}`;
        }

        // var data = 'id='+ request.variantId + '&quantity=1'
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: data,
          success: function (res) {
            SDG.Data.itemsAddedToCartQty = res.items ? res.items.length : 0;
            var mainItemInResponse = res.items.find((item) => item.product_id === SDG.Data.productId);
            const isCombinedListing = $('#combinedListing').length > 0;

            // For combined listings, use the first item if mainItemInResponse is not found.
            if (!mainItemInResponse && res.items.length > 0 && isCombinedListing) {
              mainItemInResponse = res.items[0];
            }

            if (res.items && res.items.length > 0) {
              res.items.forEach((productData) => {
                productDataAfterAdd.push(productData);
              });
            }

            var mainItemAlreadyInCart = mainItemInResponse ? $(`.js-mini-cart-item-wrapper[data-variant-id="${mainItemInResponse.id}"]`) : $();
            let qtyInCart = 0;

            if (mainItemAlreadyInCart.length > 0) {
              mainItemAlreadyInCart.each((index, cartItem) => {
                qtyInCart += Number(cartItem.dataset.quantity);
              });
            }

            SDG.Data.itemsAddedToCart = res.items;
            if (selectedGwpVariantId) {
              SDG.Data.gwpIncluded = res.items.length;
              if (SDG.disableGwpSection) SDG.disableGwpSection();
            } else {
              SDG.Data.gwpIncluded = res.items.length;
            }
            if (mainItemInResponse) {
              window.SDG.updateRemainingQtyState(mainItemInResponse.quantity);
            }
            $('.pv-memberships').addClass('pv-memberships--disabled');

            if( $(".upsell-container input[type='checkbox']:checked").length <= 0 || $('.pv-memberships').length) {
              $("#add-to-cart-btn").addClass("sold-out-btn").attr("disabled", "disabled")
              $(".product__prices").hide();
              var warningW = $(".warning-msg.limited").length;
              if(warningW == 0) {
                var limitBy = $("#product_limit").val();

                // For combined listings, get the child product's limit
                if (isCombinedListing && mainItemInResponse) {
                  const selectedInput = $(`.js-combined-item-input[value="${mainItemInResponse.id}"]`);
                  const childLimitQty = selectedInput.data('limit-quantity');
                  if (childLimitQty) {
                    limitBy = childLimitQty;
                  }
                }

                if (limitBy) {

                  if (qtyInCart > 0 && mainItemInResponse) mainItemInResponse.quantity += qtyInCart;
                  if (mainItemInResponse?.quantity >= Number(limitBy)) {
                    // For combined listings, remove any existing error before adding a new one
                    if (isCombinedListing) {
                      $(".warning-msg.limited").remove();
                    }
                    
                    var errorH = '<p class="warning-msg bold limited" style="display:block"><i class="icon icon--error-exclamation-small"></i> You have reached the limit of '+limitBy+' per order.</p>';
                    $(".product__payment-container").parents('#non-rlc-container').prepend(errorH);
                    scrollPdpErrorIfVisible($(".warning-msg.limited")[0]);
                    $('#productSizeSubmit').attr('disabled', true);
                  }
                }
              }
              // Skip errorHandling for combined listings - they manage their own state
              if (!$('#combinedListing').length) {
                errorHandling();
              }
            } else {
              $("#add-to-cart-btn").removeClass("sold-out-btn").removeAttr("disabled");
              $(".product__prices").show();
              $(".warning-msg.limited").remove();
            }
            Shopify.queue = []; // reset que since all products are processed as one
            quantity += res.items.length;
            Shopify.moveAlong();
          },
          error: function (error) {
            const response = error.responseJSON;
            if (response && response.status === 422 && response.message) {
              $(".server-msg .message").text(response.message)
              $(".server-msg").show();
              scrollPdpErrorIfVisible(document.querySelector('.server-msg.error'));
              return;
            }

            var cartBtnText = $("#add-to-cart-btn").text().trim();
            $("#add-to-cart-btn").text(cartBtnText);
          },
        });
      }
     // If the queue is empty, we add 1 to cart
    else {
      quantity += 1;
      addToCartOk(quantity);
     }
       };
       //To avoid minicart open and close issue, checking length before calling api
       Shopify.queue.length > 0 && Shopify.moveAlong();
  };

  function addToCartOk(quantity){
      var isRestrictedProduct = $('#isRestrictedProduct').val();
      var productHandle = $('#productHandle').val();

      // reset defalut select state to first for single-option-selector
      $('.single-option-selector').prop('selectedIndex', 0);
      $('.single-option-selector').trigger('change');

      // remove variant from url after adding to cart if contains ?variant=
      if (history.replaceState) {
        var cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.replaceState({path: cleanUrl}, '', cleanUrl);
      }


      if (SDG.Data.exclusiveBrand) {
        SDG.Data.exclusivePdpChecked = $('.upsell-container .checkbox-group input[type="checkbox"]:checked').length;
      }

      const bagHasPreOrder = SDG.Data.bagItems
        .find((item) => item?.selling_plan_allocation?.selling_plan || item?.full_data?.properties?._restricted_cart);
      const { bagItems } = SDG.Data;
      if (isRestrictedProduct === 'true' && bagItems.length > 0 && !bagHasPreOrder) {
        const [sameItem] = bagItems.filter((item) => item.handle === productHandle.replace('/products/', ''));
        if (sameItem) {
          updateItemQty(sameItem);
        } else {
          SDG.Data.mixedCartModal.open('modalMixedCart');
        }
        return; // escape function
      } else if ((!isRestrictedProduct || isRestrictedProduct === 'false') && bagHasPreOrder) {
        if (!SDG.Data.isUk) {
          SDG.Data.mixedCartModal.open('modalMixedCart');
          return;
        }
      }

    $('.header__cart-count').text(quantity);
    $.ajax({
      method: 'GET',
      url: `${Shopify.routes.root}cart.js`,
      dataType: 'json'
    }).then(function(cart) {
      fetch('/cart?view=data')
        .then((response) => response.json())
        .then((cartData) => {
          if (Array.isArray(cartData)) {
            window.SDG.Data.bagItems = cartData;
          }
        })
        .catch((err) => console.error(err));

      // Last parameter set to true allow to indicate the cart to force open the mini-cart)
      // Reload upsell sections to refresh cart state
      $(".upsell-container").each(function() {
        var $container = $(this);
        var containerId = $container.attr('id');
        if (containerId) {
          $container.load(window.location.href + " #" + containerId + " > *");
        }
      });
      setTimeout(function() {
        if ($(".digital-memb")[0]){
            if ($('input.digital-memb').is(':checked')){
                $(".tnc-container").show();
            }else{
                $(".tnc-container").hide();
            }
        }
        else if($('#digital_membership').val()=="enabled"){
            $(".tnc-container").hide();
        }
        var currTotal = 0;
        $('input:checkbox:checked.upsell-products').each(function () {
          var unitPrice = parseFloat($(this).data("price"));
            currTotal+=unitPrice
       });
       if(currTotal > 0){
         $(".bundle-total").text((currTotal / 100).toLocaleString(currencyFormat, localeStringParam));
       }
       var basePrice=0;

      $('.pv-memberships').addClass('pv-memberships--disabled');

       if( $(".upsell-container input[type='checkbox']:checked").length <= 0){
            $("#add-to-cart-btn").addClass("sold-out-btn").attr("disabled", "disabled")
            $(".product__prices").hide();
            $('.bundle-total').text(basePrice);
            var warningW = $(".warning-msg.limited").length;
            if(warningW == 0){
                var limitBy = $("#product_limit").val();
                const isCombinedListing = $('#combinedListing').length > 0;
                // Skip limit check for combined listings - they handle their own limit logic
                if (!isCombinedListing && limitBy && window.SDG.Data.bagItems[0].quantity >= Number(limitBy)) {
                  var errorH = '<p class="warning-msg bold limited" style="display:block"><i class="icon icon--error-exclamation-small"></i> You have reached the limit of '+limitBy+' per order.</p>';
                  $(".product__payment-container").parents('#non-rlc-container').prepend(errorH);
                  scrollPdpErrorIfVisible($(".warning-msg.limited")[0]);
                  $('#productSizeSubmit').attr('disabled', true);
                }
            }
            // Skip errorHandling for combined listings - they manage their own state
            if (!$('#combinedListing').length) {
              errorHandling();
            }
        }else{
            $("#add-to-cart-btn").removeClass("sold-out-btn").removeAttr("disabled");
            $(".product__prices").show();
            $(".warning-msg.limited").remove();
        }
     }, 2500);
      if ((SDG.Data.isCustomer && !$('.grid.grid--large[data-proceed-to-cart="false"]').length) || !SDG.Data.isCustomer) {
        var event = new CustomEvent('theme:cart:updated', {
          detail: {
            cart: cart,
            forceOpening: true,
          }
        });
        document.dispatchEvent(event);
      }
      var cartCount = $(".header__cart-count:first").text().trim();
      if(cartCount!="0"){
          $(".header__cart-count").css("display","block");
      }else{
        $(".header__cart-count").css("display","none");
      }

      // Adding Klaviyo tracking for quick add to cart
      const _learnq = window._learnq || []; // eslint-disable-line
      if (_learnq) {
        _learnq.push(['track', 'Added to Cart', {
          total_price: cart.total_price/100,
          $value: cart.total_price/100,
          total_discount: cart.total_discount,
          original_total_price: cart.original_total_price/100,
          items: cart.items
        }]);
      }

      const $crossSellInput = $('input[properties="_cross_sell_product_sku"]').val();
      const $upgradeOption = $('input[properties="_upgrade_option"]').val();
      const $ageGrade = $('#pdp_age_grade').val();
      const $badge = $('#pdp_badge').val();
      const $addToCartType = $('#pdpAddToCartType').val();
      const $category1 = $('#pdpProductCategory').val();
      const $category2 = $('#pdpProductCategory2').val();
      const $coupon = $('#pdpCouponText').val();
      const $discount = $('#discount-amount').val().replace(/\,/g, '.');
      const crossSellProduct = $crossSellInput ? true : false;
      const crossSellProductSku = $crossSellInput ? $crossSellInput : '';
      const variantTitle = product.variant_title;
      let itemSize = '';
      let itemColor = null;

      if (variantTitle && !variantTitle.includes('Default')) {
        const [sizeTitle, colorTitle] = variantTitle.split(' / ');
        itemSize = sizeTitle;
        itemColor = colorTitle;
      }

      const gtmItemData = productDataAfterAdd.map((product, dataIndex) => {
       return {
         'index': dataIndex,
         'age_group': $ageGrade || '',
         'item_id': product.sku.split('_')[0],
         'item_sku': product.sku,
         'item_badge': $badge || '',
         'item_list_type': product.properties?._item_list_type || undefined,
         'item_name': product.title,
         'item_brand': product.vendor,
         'item_category': $category1,
         'item_category2': $category2 || '',
         'merch_vendor': product.vendor,
         'product_availability': 'available',
         'price': __.formatPrice(product.price),
         'discount': $discount || '0.00',
         'original_price': __.formatPrice(product.original_price),
         'item_bundle': 'true',
         'item_bundle_sku': '',
         'item_variant': product.id,
         'item_size': itemSize,
         'item_color': itemColor || '',
         'quantity': product.quantity,
         'cross_sell_product': crossSellProduct,
         'cross_sell_product_sku': crossSellProductSku,
         'upgrade_option': product.properties._upgrade_option || '',
         'item_promo': $coupon !== '' ? 'true' : 'false',
         'coupon': $coupon || '',
       }
      });
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
          'currency': Shopify.currency.active,
          'cart_id': cart.token,
          ...(SDG.Data.customerEmail !== null && {authentication_status: true}),
          ...(SDG.Data.customerEmail === null && {authentication_status: false}),
          'add_to_cart_type': $addToCartType,
          'items': gtmItemData
        }
      });
    });

    $(".pdp-sticky-atc").removeClass("button--loading pdp-sticky-atc--loading").removeAttr("disabled");
  }
function validateEmail(emailValue,ele,isAgreementChecked){
    var emailRegex=/^([a-zA-Z]+[a-zA-Z0-9_\-\+\.]+)@((([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if(emailValue=="" || emailValue==undefined){
            ele.siblings('.signupError').addClass('active').stop().delay(500).queue('',function(){
                ele.siblings('.signupError').removeClass('active');
            });
            ele.siblings('.signupError').html(ele.data('empty'))
        }
        else if(!emailRegex.test(emailValue)){
            ele.siblings('.signupError').addClass('active').stop().delay(500).queue('',function(){
                ele.siblings('.signupError').removeClass('active');
            });
            ele.siblings('.signupError').html(ele.data('error'))
        }
        else if(!isAgreementChecked){
            ele.siblings('.signupError').addClass('active').stop().delay(500).queue('',function(){
                ele.siblings('.signupError').removeClass('active');
            });
            ele.siblings('.signupError').html(ele.data('membershipunchecked'))
        }
        else{
          if ($(".template-page-membership")[0]){
            if($.cookie("email") && $.cookie("email")==emailValue ){
               var redirectURL = $("#prod_redirect_url").val();
                if(redirectURL != ""){
                  window.location.href = redirectURL;
                }
            }
            else{
              setCookie("email",emailValue,"2");
            }
          }
           if ($(".brand-landing-page")[0]){
               $('#emailAddress1').val(emailValue);
               var brand='email_'+$('#brandValue').val()+'_membership,email_mc_memberhship';
               brand = 'newsletter,'+brand;
               $('#memberlpFields').val(brand);
               sessionStorage.setItem("newsletterSectionId", 'tar-membership');
               $('form.success-modal').submit();
           }
           if ($(".crowdfunding-waiting")[0]){
                $("#prefilledEmail").val(emailValue);
        -       ele.parents('.crowdfunding-waiting').find('.newsletter-modal-wrap.form').removeClass('hide')
           }
        }
}

$(document).ready(function() {
    $('.js-logout-link').on("click", function(e) {
         e.preventDefault();
      $.ajax( $(this).attr('href') ).done(function() {
        // setCookie("email","","0");
        function deleteAllCookies(){
            var cookies = document.cookie.split(";");
            for (var i = 0; i < cookies.length; i++)
              deleteCookie(cookies[i].split("=")[0]);
          }
            function deleteCookie(name){
              setCookie(name,"",-1);
            }
        deleteAllCookies();
        var returnURI= encodeURIComponent(document.location.pathname + document.location.search);
        const {
          mattelLogoutUrl,
          mattelShopUrl,
          mattelClientId,
        } = SDG.Data;
        window.location.replace(`${mattelLogoutUrl}?client_id=${mattelClientId}&post_logout_redirect_uri=https://${mattelShopUrl}`);
    });
   });
});

function setCookie(name, value, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
  if ($.cookie('email')) {
    $("#Email-footer").val(value);
    $("#newsletter-btn").trigger("click");
  }
}
function setGridHeight(element){
    var maxHeight=0;

    if (element?.classList?.contains('js-pastproject-cell')) return;

    element.each(function(index,ele){
           maxHeight =ele.offsetHeight > maxHeight ? ele.offsetHeight : maxHeight;
    });
    element.css('min-height',maxHeight);
}
function cartMembershiplacement(){
    if($(window).width()>1023){
        return;
    }
    $('tr.js-cart-prompt').each(function() {
        var $row = $(this);
        var $td = $row.children('td');
        var $content = $row.find('.js-cart-prompt-body').first();
        if (!$td.length || !$content.length) {
            return;
        }
        // Only move this row's upsell controls — not every div under every .cart-prompt__body (avoids pooled checkboxes / buttons).
        $content.children('div, button').appendTo($td);
    });
}
$(window).resize(function(){
    cartMembershiplacement();
});
var quantityBtn = document.querySelectorAll('.js-cart-quantity-button');
quantityBtn.forEach(element => {
  element.addEventListener('click', (e)=> {
    e.preventDefault();
    var line_count = element.getAttribute('data-line-count');
    var line_quantity = element.getAttribute('data-next-quantity');
    var line_key = element.getAttribute('data-line-key');
    var cartUpdates = {};
    cartUpdates[line_key] = parseInt(line_quantity);
    var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json',
        success: function(stuff) {
          document.location.reload();
        },
        error: function(error) {
            console.log(error.status);
        }
    };
    $.ajax(params);
  });
});

ReturnLabelJS={

    processFedExForm: function() {

      console.log('ReturnLabelJS.processFedExForm entry');
        var form_error =0;
        var errors = false;
        if (document.fedexform.firstname.value == "") {
          errors = true;
          alert("Please enter your first name");
          form_error++;
             gtagformError_return("First Name","Please enter your first name");
        }else if (document.fedexform.txtContactName.value == "") {
          errors = true;
          alert("Please enter your last name");
              form_error++;
             gtagformError_return("Last Name","Please enter your last name");
        }else if (document.fedexform.ddlUSAStates.value == -1) {
          errors = true;
          alert("Please select your state");
          form_error++;
             gtagformError_return("State","Please select your state");
        }else if (document.fedexform.txtPostalCode.value == "") {
          errors = true;
          alert("Please enter your zip code");
          form_error++;
             gtagformError_return("Zip Code","Please enter your zip code");
        }


        if (errors == true) {
          return false;
        } else {
           gtagformSubmit_return('content_area','Return Policy');
          var lastname = document.fedexform.txtContactName.value;
          var zip = document.fedexform.txtPostalCode.value;
          document.fedexform.txtRMANumber.value = lastname.toUpperCase() + zip;
          //document.fedexform.submit();
          var countryCode = document.fedexform.txtCountryCode.value;

          if(countryCode == "undefined") {
            var element=document.getElementById("txtCountryCode");
            var domElement=document.createElement("input");
            domElement.setAttribute("name", "txtCountryCode");
            domElement.setAttribute("type", "text");
            domElement.setAttribute("class", "hide");
            domElement.setAttribute("id","txtCountryCode");
            domElement.setAttribute("maxlength","15");
            domElement.setAttribute("value","US");
            element.parentElement.appendChild(domElement);
          }
          var url =
    "https://api.platform.mattel/v1/es/generatereturnlabel/store/10151?responseFormat=json&updateCookies=true&api_key=6qrJDBGTpipuBq8u6i/P0BBcl3FDPi3Qrt6XdhDngp/kw7YJ";

           var postData = {"firstName":document.fedexform.firstname.value,"lastName":lastname,"state":document.fedexform.ddlUSAStates.value,"zipCode":zip,"isGT":"N"};
            $.ajax({
                url: url,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify( postData ),
                success: function(r){
                   var arrBuffer = base64ToArrayBuffer(r.image);
                   var a = new Blob([arrBuffer],{
                               type: "application/pdf"
                           });

                   function base64ToArrayBuffer(data) {
                       var binaryString = window.atob(data);
                       var binaryLen = binaryString.length;
                       var bytes = new Uint8Array(binaryLen);
                       for (var i = 0; i < binaryLen; i++) {
                           var ascii = binaryString.charCodeAt(i);
                           bytes[i] = ascii;
                       }
                       return bytes;
                   };
                           if (window.navigator && window.navigator.msSaveOrOpenBlob)
                               return void window.navigator.msSaveOrOpenBlob(a);
                           var t = window.URL.createObjectURL(a);
                           setTimeout(function() {
                               window.open(t, "_blank")
                           }, 100)
                },
                error: function(){
                    console.log('error generating return label');
                }
            });
        }

        console.log('ReturnLabelJS.processFedExForm exit');
       }
    }

/* script for custom List Dropdown */

// To close the dropdown on click outside it
$(window).click(function() {
    $('.list_dropdown.opened>ul').hide();
    $('.list_dropdown.opened').removeClass( "opened" );
});

// To fix the on click outside dropdown event bug
$('.list_dropdown').click(function(event){
    event.stopPropagation();
});

// Toggling the dropdown list
$('.list_dropdown>div').on('click',function() {
    $(this).next().toggle();
    $(this).parent().toggleClass( "opened" );
});

// Triggering the filter action on click of dropdown option
$('.list_dropdown>ul li').on('click',function() {
    var value = $(this).text();
    var type = ($(this).data("dropdown-type"));
    $(this).parent().prev().find(".selected").text(value);
    if(type=="collection"){
        window.location.href = $(this).data("dropdown-value");
    }
    if(type=="sort"){
        Shopify.queryParams.sort_by = $(this).data("dropdown-value");
        location.search = $.param(Shopify.queryParams);
    }
});

// end of List Dropdown

// login script

// Redirect login anchor to login page
$('a.accountAction_button').on("click", function(e){
    if($(this).attr('href').indexOf("/account/login")!=-1)
    {
        e.preventDefault();
        var returnURI= encodeURIComponent(document.location.href);
        window.location.replace("https://platform.mattel/shopify/login?shop_url=https%3A%2F%2Fprod-collectorshub.myshopify.com&return_to="+returnURI+"&client_id=collectorshub");
    }
    else if($(this).attr('href').indexOf("/account/register")!=-1)
    {
        e.preventDefault();
        var returnURI= encodeURIComponent(document.location.href);
        window.location.replace("https://platform.mattel/shopify/login?shop_url=https%3A%2F%2Fprod-collectorshub.myshopify.com&return_to="+returnURI+"&client_id=collectorshub&action=register");
    }
    else {

    }
});

// // Redirecting all login buttons to login page
// $('.login_button').on('click',function(e){
//     e.preventDefault();
//     var returnURI= encodeURIComponent(document.location.href);
//     window.location.replace("https://platform.mattel/shopify/login?shop_url=https%3A%2F%2Fprod-collectorshub.myshopify.com&return_to="+returnURI+"&client_id=collectorshub&action=register");
// });
/*
function triggerTags(cat, act, lbl, evname, desc, pos, login_status){
    try{
        utag.link({event_category:cat, event_action:act, event_label: lbl, event_name:evname, event_description: desc, event_pos: pos,logged_in_status: login_status});
    }
    catch(error){
        console.error(error);
    }
}*/
function gtagSelectitem(prodTitle, productSKU, prodVendor, prodprice, prodId, prodCat, discount, originalPrice, prodIndex, listName, ageGrade, badge, prodCat2, qty, variantId, couponText){
  var productTitle = __.removeChars(prodTitle, gtmChars);
  var crossSellProduct = productSKU === sessionStorage.getItem('crossSellProductSku') ? true : false;
  var crossSellProductSku = productSKU === sessionStorage.getItem('crossSellProductSku') ? productSKU : undefined;

   window.dataLayer.push({ ecommerce: null });
   window.dataLayer.push({
     'event':'select_item',
     'ecommerce':{
       'item_list_name':listName,
       'currency':Shopify.currency.active,
       'items':[{
         'age_group': ageGrade || '',
         'cross_sell_product': crossSellProduct,
         'cross_sell_product_sku': crossSellProductSku,
         'index': prodIndex,
         'quantity': qty || '',
         'item_id':productSKU.split('_')[0],
         'item_sku':productSKU,
         'item_name':productTitle,
         'item_brand':prodVendor,
         'item_badge':badge || '',
         'item_category':prodCat,
         'item_category2':prodCat2 || '',
         'merch_vendor': prodVendor,
         'product_availability':$("#product-availability").val(),
         'price':prodprice,
         'discount':discount,
         'original_price':originalPrice,
         'item_variant':variantId,
         'item_promo': couponText ? couponText : undefined,
         'coupon': undefined,
       }]
     }
  });
  sessionStorage.setItem('crossSellProduct', true);
  sessionStorage.setItem('crossSellProductSku', productSKU);
}

function gtag(){dataLayer.push(arguments);}

function load(url) {
  return new Promise(async function (resolve, reject) {
    // do async thing
    const res = await fetch(url);

    // resolve
    resolve(res.json()) // see note below!
  })
}

function gtagEvents(pid, id, sku, type, title, vendor, price, ageGrade, badge, category2, addToCartType, upgradeOption, dataProductSku){
  var productTitle = __.removeChars(title, gtmChars);
  var crossSellProduct = dataProductSku ? true : false;
  var crossSellProductSku = dataProductSku ? dataProductSku : '';

  // run the function and receive a Promise
  const promise = load('/cart.json');

  // let the Promise know what you want to do when it resolves
  promise.then((response) => {
    const cartData = response;
    const cartId = cartData.token;

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
       'event': 'add_to_cart',
       'ecommerce': {
         'currency': Shopify.currency.active,
         'cart_id': cartId,
         ...(SDG.Data.customerEmail !== null && {authentication_status: true}),
         ...(SDG.Data.customerEmail === null && {authentication_status: false}),
         'items': [{
           'index': 1,
           'add_to_cart_type': addToCartType,
           'age_group': ageGrade,
           'item_id': sku.split('_')[0],
           'item_sku': sku,
           'item_badge': badge || '',
           'item_name': productTitle,
           'item_brand': vendor,
           'item_category': type,
           'item_category2': category2 || '',
           'merch_vendor': vendor,
           'product_availability': $('#product-availability').val(),
           'price': price,
           'discount': $('#discount-amount').val(),
           'original_price': price,
           'item_bundle': 'false',
           'item_bundle_sku': '',
           'item_variant': id,
           'item_size': $('#variantweight').val(),
           'quantity': $('#product-quantity').val(),
           'cross_sell_product': crossSellProduct,
           'cross_sell_product_sku': crossSellProductSku,
           'upgrade_option': upgradeOption || '',
         }]
       }
    });
  });
}
function pageOnLoadChecker(loading, loaded) {
    if(document.readyState === 'complete'){
        return loaded();
    }
    loading();
    if (window.addEventListener) {
        window.addEventListener('load', loaded, false);
    }
    else if (window.attachEvent) {
        window.attachEvent('onload', loaded);
    }
};

const cssClasses = {
    collectionSidebar: '.collection-sidebar',
    accordionHeading: '.accordion-heading',
    accordionContent: '.accordion-content',
    filterItem: '.collection-sidebar__filter-item',
    filter: '.collection-sidebar__filter-items',
    clearTags: '.collection-filter_clear-tags',
    mobileTrigger: '.mobile_filter-trigger',
    filterCount: '.filters_count'
};

// Accordion
const accordionHeading = $(cssClasses.accordionHeading);

accordionHeading.on('click', function () {
    const parentItem = $(this).parent();
    const content = parentItem.find(cssClasses.accordionContent).first();

    $(this).toggleClass('open');
    content.slideToggle();
});


function filtertriggerCode(){
    if($(cssClasses.collectionSidebar).hasClass("open")){
        $('.collection-sidebar').toggleClass("open");
        setTimeout(function(){ $('body').toggleClass('mobile-filter-open'); }, 250);
    }else{
        $('.collection-sidebar').css('visibility','visible').toggleClass("open");
        setTimeout(function(){ $('body').toggleClass('mobile-filter-open'); }, 250);
    }
}
// Tag filter
const url = window.location.origin + window.location.pathname;
const filterItem = $(cssClasses.filterItem);
const clearTags = $(cssClasses.clearTags);
let collectionUrl = $(cssClasses.collectionSidebar).data('collection-url');
let mobileFilterTrigger = $(cssClasses.mobileTrigger);
mobileFilterTrigger.on('click', function(e) {
    filtertriggerCode();
});
$(document).on('click', '.mobile-filter-open .collection-sidebar', function(e){
    var cThis = $(this);
    if ($(e.target).closest(".sidebar__wrapper_content").length === 0) {
        filtertriggerCode();
    }
})
// let currentActiveTags = [];
// for (var i = 0; i < localStorage.length; i++){
//     // $('body').append(localStorage.getItem(localStorage.key(i)));
//     if(localStorage.key(i).includes("collection") && localStorage.key(i) != collectionUrl) {
//         localStorage.removeItem(localStorage.key(i));
//     }
// }
// if(localStorage.getItem(collectionUrl) != null) {
//     currentActiveTags = localStorage.getItem(collectionUrl).split(',');
// }
// var activeTagContainer = document.querySelector('.collection-filter_active-tags');
// if(currentActiveTags.length > 0) {
//     activeTagContainer.hidden = false;
//     var temp = [];
//     for(let i=0; i<currentActiveTags.length; i++) {
//         var tagArray = currentActiveTags[i].split("/");
//         var tag = tagArray[0];
//         document.querySelector(`.collection-sidebar__filter-item[data-tag="${tag}"]`).classList.add("active");
//         var tagName = tagArray[1];
//         var li = document.createElement('LI');
//         li.innerText = tagName;
//         li.setAttribute('data-tag',tag);
//         li.classList.add("collection-filter_active-tag");
//         li.onclick = function(event) {
//             document.querySelector(`.collection-sidebar__filter-item[data-tag="${tag}"]`).click();
//         }
//         activeTagContainer.prepend(li);
//         temp.push(tag);
//     }
//     let sheetToBeAdded = document.getElementById('collectionFiltertStyle');
//     if(sheetToBeAdded == undefined) {
//         var collectionFilterStyle = document.createElement('style');
//         collectionFilterStyle.id = "collectionFiltertStyle";
//     } else {
//         var collectionFilterStyle = sheetToBeAdded;
//     }
//     activeTagString = temp.join(', .');
//     collectionFilterStyle.innerHTML = `.collection-grid__product {display: none !important;} .${activeTagString} {display: flex !important;}`;
//     document.body.appendChild(collectionFilterStyle);
//     console.log('added');
// }
function searchPageFilter(tag){
    var searchClass = $('.template-search');
    var tagC = tag[0];
    var productContainer = searchClass.find('.collection_main .list-products');
    var npC = productContainer.find('p.no-products');
    if(searchClass.length > 0 && typeof tagC !='undefined'){

      var hasP = true;

      var findP =  searchClass.find('.list-products .'+tagC).length;
      if(findP <= 0){
        hasP = false;
      }
      if(hasP == false){
        if(npC.hasClass('hide')){
          npC.removeClass('hide');
        }
      }
      else{
        if(!npC.hasClass('hide')){
          npC.addClass('hide');
        }
      }

    }
    else{
      if(!npC.hasClass('hide')){
        npC.addClass('hide');
      }
    }
  }
var productsContainer = $('.collection-grid__products');

clearTags.on('click', function() {
    let sheetToBeRemoved = document.getElementById('collectionFiltertStyle');
    var sheetParent = sheetToBeRemoved.parentNode;
    sheetParent.removeChild(sheetToBeRemoved);
    var activeItems = $('.collection-sidebar').find(cssClasses.filterItem + '.active');
    activeItems.each(function (index, el) {
        el.classList.remove('active');
    });
    var activeTags = $('.collection-filter_active-tags').find('li.collection-filter_active-tag');
    activeTags.each(function (index, el) {
        el.remove();
    });
    var activeTagContainer = document.querySelectorAll('.collection-filter_active-tags');
    activeTagContainer.forEach(element => {
        element.hidden = true;
    });
    document.querySelector(cssClasses.filterCount).hidden = true;
    document.querySelector(cssClasses.filterCount).innerText = '';
});

filterItem.on('click', function () {
    let search = window.location.search;

    if (search.indexOf('page') !== -1) {
        const pageParam = search.split("&")[0];
        search = search.replace(pageParam, '').replace('&', '?');
    }

    const filter = $(this).parents('[data-filter]');
    const filterItems = filter.find(cssClasses.filterItem);
    var hasActiveClass = false;
    if ($(this).hasClass('active')) {
        hasActiveClass = true;
    }

    if(hasActiveClass) {
        let tag = $(this).attr('data-tag');
        activeTagToBeRemoved = document.querySelectorAll(`.collection-filter_active-tag[data-tag="${tag}"]`);
        activeTagToBeRemoved.forEach(element => {
            element.remove();
        });
    }
    $(this).toggleClass('active');

    var activeItems = $('.collection-sidebar').find(cssClasses.filterItem + '.active');
    var activeTags = [];

    activeItems.each(function (index, el) {
        var tag = $(el).attr('data-tag');
        var tagname = $(el).attr('data-tag-name');
        if (tag) {
            activeTags.push(tag);
        }
    });
    var activeTagContainer = document.querySelectorAll('.collection-filter_active-tags');
    if(!hasActiveClass) {
        let tag = $(this).attr('data-tag');
        var tagName = $(this).attr('data-tag-name');
        var li = document.createElement('LI');
        li.innerText = tagName;
        li.setAttribute('data-tag',tag);
        li.classList.add("collection-filter_active-tag");
        activeTagContainer.forEach(element => {
            var tagelement = null;
            tagelement = li.cloneNode(true);
            tagelement.onclick = function(event) {
                document.querySelector(`.collection-sidebar__filter-item[data-tag="${tag}"]`).click();
            }
            element.prepend(tagelement);
        });
    }
    if(activeTags.length > 0) {
        activeTagContainer.forEach(element => {
            element.hidden = false;
        });
        document.querySelector(cssClasses.filterCount).hidden = false;
        document.querySelector(cssClasses.filterCount).innerText = `(${activeTags.length})`;
        let sheetToBeAdded = document.getElementById('collectionFiltertStyle');
        if(sheetToBeAdded == undefined) {
            var collectionFilterStyle = document.createElement('style');
            collectionFilterStyle.id = "collectionFiltertStyle";
        } else {
            var collectionFilterStyle = sheetToBeAdded;
        }
        activeTagString = activeTags.join(', .');
        collectionFilterStyle.innerHTML = `.collection-grid__product {display: none !important;} .${activeTagString} {display: inline-block !important;}`;
        document.body.appendChild(collectionFilterStyle);
        searchPageFilter(activeTags);
    } else {
        activeTagContainer.forEach(element => {
            element.hidden = true;
        });
        document.querySelector(cssClasses.filterCount).hidden = true;
        document.querySelector(cssClasses.filterCount).innerText = '';
        let sheetToBeRemoved = document.getElementById('collectionFiltertStyle');
        var sheetParent = sheetToBeRemoved.parentNode;
        sheetParent.removeChild(sheetToBeRemoved);
        searchPageFilter(activeTags);
    }
});
function setMenuheightDynamic(){
    var $items = $('.header__main-nav .nav-dropdown--first > .container > ul > li:not(:first-child)');
    if(!$items.length) return;

    // Reset any previous min-heights so natural heights are measured accurately
    $items.css('min-height', '');

    // Derive column count from actual widths (CSS sets each li to 25% of the ul)
    var columns = Math.round($items.first().parent().innerWidth() / $items.first().outerWidth(true)) || 4;

    // Group items into rows of `columns` and equalize each row's height
    var itemsArray = $items.toArray();
    for(var i = 0; i < itemsArray.length; i += columns){
        var rowItems = itemsArray.slice(i, i + columns);
        var maxHeight = 0;
        $(rowItems).each(function(){
            var h = $(this).height();
            if(h > maxHeight) maxHeight = h;
        });
        $(rowItems).css('min-height', maxHeight);
    }
}
function setInfoheight(startIndex,endIndex,infoheight,dateHeight,isPastgridItem){
    $('.eapp-events-calendar-grid-item').each(function(index){
        if(index >= startIndex && index <= endIndex){
            if ($(window).width() >= 1024) {
            $(this).find('.grid-info-text-wrapper').css('height',infoheight);
            $(this).find('.eapp-events-calendar-grid-item-date').css('height',dateHeight);
            }
        }
    })
}
var contact__topic = $(".contact__topic");
if(contact__topic.length>0){
if ($(window).width() < 768) {
    $('.contact__topic').select2({
    containerCssClass: "wrap",
    minimumResultsForSearch: -1,
    placeholder: "Please Select A Topic",
    selectOnClose: true
    });
    }
}
function browserBackBtnClick(){
    if (window.history && window.history.pushState) {
        $(window).on('popstate', function() {
          var prenHref = localStorage.getItem("currentHref");
          if(prenHref){
			if(prenHref.includes('?')){
				location.href= location.pathname
			}
		  }
        });
    }
  }
function filteredUrl(){
    var getFiltereditem=window.location.href.split('?')[1];
    if(getFiltereditem){
      getFiltereditem=getFiltereditem.replaceAll("%20"," ");
      $('.eapp-events-calendar-filter-currentText').text(getFiltereditem);
    }
    else{
      $('.eapp-events-calendar-filter-currentText').text("All Brands");
    }
    $('.eapp-events-calendar-filter-modal>div div').each(function(){
      if($(this).attr('title') == getFiltereditem){
        $(this).click();
        $('.eapp-events-calendar-filter-modal').removeClass('eapp-events-calendar-filter-show');
      }
    });
    setTimeout(function(){
      launchCalendar();
      gridEventclick();
      $('.calendar-events-wrapper div[class*="elfsight-"]').css('height','auto').css('opacity','1');
      $('.calendar-loader').removeClass('showloader');
    },200);
}
function launchCalendar(){

    $('.eapp-events-calendar-filter-modal>div div').each(function(){
      if(!$(this).attr('title')){
        $(this).text("All Brands");
      }

    })
    $(document).on('DOMSubtreeModified', ".eapp-events-calendar-filter-currentText", function() {
        var thisE = $(this);
        var content = thisE.text();
        var len = content.length;
        len = parseInt(len);
        console.log(thisE.parents());
        if(len > 19){
          thisE.parents('.eapp-events-calendar-filter-component').addClass('increasedWidth');
        }
        else{
          thisE.parents('.eapp-events-calendar-filter-component').removeClass('increasedWidth');
        }
        if($('.eapp-events-calendar-filter-currentText').text()=="Brand"){
            $('.eapp-events-calendar-filter-currentText').text("All Brands");
        }
         else{
               var currentURL = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + $('.eapp-events-calendar-filter-currentText').text();

        window.history.pushState({ path: currentURL }, '', currentURL);
        localStorage.setItem("currentHref", window.location.href);
         }
      });
     /* Adding class names for font styling */
       $('.eapp-events-calendar-grid-item-name').addClass('h5');
       $('.eapp-events-calendar-tags-item').addClass('h6');
       $('.eapp-events-calendar-button-link').addClass('copy-medium');
       /* Appending all grid groups(for every month data) into the single group
       $('.eapp-events-calendar-grid-group').each(function(index){
         if(index!=0){
             $('.eapp-events-calendar-grid-group:eq(0) .eapp-events-calendar-grid-component').append($('.eapp-events-calendar-grid-group:eq(' + index + ') .eapp-events-calendar-grid-item'));
         }
       })*/
       /*Member exclusive*/
       var $gridItemcount;
       var isPastgridItem = false;
       var startIndex=0,endIndex;
       var infoHeight=0,dateHeight=0;
       $('.eapp-events-calendar-grid-item').each(function(index){

         var $items= $(this).find('.eapp-events-calendar-grid-item-tags .eapp-events-calendar-tags-item');
         var $tagElement='', $saleElement='',$dateElement='',$tagText,$saleHtml,$tagName,eventName;
         $(this).find('.eapp-events-calendar-category-component,.eapp-events-calendar-grid-item-name,.eapp-events-calendar-grid-item-tags,.eapp-events-calendar-grid-item-locationAndTime').wrapAll('<div class="grid-info-text-wrapper" />')
         $items.each(function(){
            $tagText=$(this).html();
            if($tagText.includes('Tag:') ){
             $tagName = $tagText.split('Tag:')[1];
             $tagElement+='<div class="eapp-events-calendar-membership-tag">'+$tagName+'</div>';
             $(this).parents('.eapp-events-calendar-grid-item-info').prevAll('.eapp-events-calendar-grid-item-imageContainer').append($tagElement);
                $(this).remove();
           }
           if($tagText.includes('Onsalelabel:') ){
             $tagName = $tagText.split('Onsalelabel:')[1];
             $saleElement+='<div class="eapp-events-calendar-onsale-tag">'+$tagName+'</div>';
             $(this).parents('.eapp-events-calendar-grid-item-info').prevAll('.eapp-events-calendar-grid-item-date').append($saleElement);
             $(this).remove();
           }
           if($tagText.includes('Productdateunavailable:') ){
             $tagName = $tagText.split('Productdateunavailable:')[1];
             $dateElement+='<div class="eapp-events-calendar-product-nodate">'+$tagName+'</div>';
             $(this).parents('.eapp-events-calendar-grid-item-info').prevAll('.eapp-events-calendar-grid-item-date').append($dateElement);
             $(this).parents('.eapp-events-calendar-grid-item-info').prevAll('.eapp-events-calendar-grid-item-date').find('.eapp-events-calendar-date-element-start').remove();
             $(this).remove();
           }
            if($tagText.includes('Pdplink:') ){
             $tagName = $tagText.split('Pdplink:')[1];
             $(this).parents('.eapp-events-calendar-grid-item-info').prevAll('.eapp-events-calendar-date-element-component').wrapAll('<a href='+$tagName+' style="position:relative;z-index:5;width:100%;" class="pdp-link"></a>');
             $(this).parents('.eapp-events-calendar-grid-item-info').prev('.eapp-events-calendar-grid-item-imageContainer').wrapAll('<a href='+$tagName+' style="position:relative;z-index:4;width:100%;" class="pdp-link"></a>');
             $(this).parents('.eapp-events-calendar-grid-item-info').find('.eapp-events-calendar-grid-item-name').wrapAll('<a href='+$tagName+' style="position:relative;z-index:5;width:100%;" class="pdp-link"></a>');
              $(this).remove();
           }
           if($tagText.includes('Modaltitle:') || $tagText.includes('Modaldescription:')){
                $(this).remove();
           }
           if($tagText.includes('SKU:')){
             $(this).attr('data-sku',$tagText.split('SKU:')[1]);
             $(this).css('display','none');
           }
           if($tagText.includes('Category:')){
             $(this).attr('data-category',$tagText.split('Category:')[1]);
               $(this).css('display','none');
           }
         })
          /*Truncate and show elipsis */
          eventName = $(this).find('.eapp-events-calendar-grid-item-name').text();
          truncateProdname(eventName,$(this).find('.eapp-events-calendar-grid-item-name'));
         /*set min height based on grid info */
         startIndex = startIndex ;
         endIndex = startIndex + 2;
         if(index >= startIndex && index <= endIndex){
            var getInfoheight=$(this).find('.grid-info-text-wrapper').height();
            if(getInfoheight > infoHeight){
                infoHeight=getInfoheight;
            }
            var getDatefieldHeight=$(this).find('.eapp-events-calendar-grid-item-date').height()+40;
            if(getDatefieldHeight > dateHeight){
                dateHeight=getDatefieldHeight;
            }
         }
         if($(this).closest('.eapp-events-calendar-layout-pastEvents').length){
           $gridItemcount=$('.eapp-events-calendar-layout-pastEvents .eapp-events-calendar-grid-item').length-1;
           isPastgridItem=true;
         }
         else{
           $gridItemcount = $('.eapp-events-calendar-events-calendar-layout > .eapp-events-calendar-grid-component .eapp-events-calendar-grid-item').length-1;
         }
         if($gridItemcount >= endIndex){
            if(index == endIndex){
                setInfoheight(startIndex,endIndex,infoHeight,dateHeight,isPastgridItem);
                startIndex=endIndex+1;
                infoHeight=0;
                dateHeight=0;
            }
         }
         else if(!isPastgridItem){
           if(index == $gridItemcount){
             setInfoheight(startIndex,$gridItemcount,infoHeight,dateHeight,isPastgridItem);
             startIndex=$gridItemcount+1;
              infoHeight=0;
              dateHeight=0;
           }
         }
         else{
              setInfoheight(startIndex,endIndex,infoHeight,dateHeight,isPastgridItem);
           }


         /* preventing click anywhere on grid item */
         var $calendarCtahtml = $(this).find('.eapp-events-calendar-grid-item-info').find('.eapp-events-calendar-grid-item-button').html();
         $(this).find('.eapp-events-calendar-grid-item-info').find('.eapp-events-calendar-grid-item-button').remove();
         $(this).find('.eapp-events-calendar-grid-item-component').append('<div class="jsx-3379200277 eapp-events-calendar-button-element-component eapp-events-calendar-grid-item-button">'+$calendarCtahtml+'</div>');
           //$(".eapp-events-calendar-grid-item-button:nth-child(1)").detach().appendTo('.eapp-events-calendar-grid-item-component:nth-child(1)');
         $('.eapp-events-calendar-grid-item-date,.eapp-events-calendar-grid-item-imageContainer,.eapp-events-calendar-grid-item-info').click(function(e){
           e.stopPropagation();
         });
                  /*fixes for CTA `not clickable after filtering */
         var $calendarCta = $(this).find('.eapp-events-calendar-grid-item-button .eapp-events-calendar-button-component').html();
         $(this).find('.eapp-events-calendar-grid-item-button .eapp-events-calendar-button-component').html($calendarCta);
          /* Hiding button when it is turned off */
         if($(this).find('.eapp-events-calendar-grid-item-component .eapp-events-calendar-grid-item-button').text()=='undefined' || $(this).find('.eapp-events-calendar-grid-item-component .eapp-events-calendar-grid-item-button').text()==''){
             $(this).find('.eapp-events-calendar-grid-item-component .eapp-events-calendar-grid-item-button').css('display','none');
         }
       });

}
function truncateProdname(text,ele){
     if ($(window).width() >= 1024) {
        if(text.length >62 ){
            ele.html(text.substring(0, 62) + '...');
        }
    }
        else{
        if(text.length >68 ){
            ele.html(text.substring(0, 68) + '...');
        }
    }
}
function gridEventclick(){
     $('.eapp-events-calendar-grid-item-component .eapp-events-calendar-button-component').on('click',function(){
     var checkExist = setInterval(function() {
       if ($('.eapp-events-calendar-modal-overlay-component').length) {
            clearInterval(checkExist);

        /*    $('.eapp-events-calendar-modal-overlay-component').html('');
            $('.eapp-events-calendar-modal-overlay-component').append('<div class="loaderelement"></div>');
            $('.eapp-events-calendar-event-viewer-modalContent').css('opacity','0');*/
            gridModal();
       }
        });
     });
}

function gridModal(){
      var calendarTitle='',calendarDate='';


       $('.eapp-events-calendar-popup-item-category').addClass('copy-large');
       $('.eapp-events-calendar-popup-item-header p').addClass('copy-medium');
       $('.eapp-events-calendar-popup-item-name').addClass('h5');
       $('.eapp-events-calendar-tags-item').addClass('h6');
       $('.eapp-events-calendar-popup-item-header').insertAfter('.eapp-events-calendar-popup-item-media');
       $('.eapp-events-calendar-popup-item-description').insertAfter('.eapp-events-calendar-popup-item-close');
       /*Truncate and show elipsis */
          modalEventname =  $('.eapp-events-calendar-popup-item-name').text();
          truncateProdname(modalEventname,$('.eapp-events-calendar-popup-item-name'));
       /*if($('.eapp-events-calendar-read-more-content div:first-child').html().includes('<div>')){
           if($('.eapp-events-calendar-read-more-content div:first-child').html().split('<div>')[0].split('Title:')[1] != undefined ){
               calendarTitle+='<h3>'+$('.eapp-events-calendar-read-more-content div:first-child').html().split('<div>')[0].split('Title:')[1]+'</h3>';
           }

           if($('.eapp-events-calendar-read-more-content div:first-child').html().split('<div>')[1].split('Desc:')[1] != undefined ){
            calendarTitle+='<p>'+$('.eapp-events-calendar-read-more-content div:first-child').html().split('<div>')[1].split('Desc:')[1]+'</p>';
           }
       }
           $('.eapp-events-calendar-read-more-content').html(calendarTitle);
               $('.eapp-events-calendar-read-more-content p').insertBefore('.eapp-events-calendar-popup-item-header .eapp-events-calendar-category-component');*/

         $('.eapp-events-calendar-popup-item-inner .eapp-events-calendar-popup-item-tags .eapp-events-calendar-tags-item').each(function(){
            var $modalTagtext=$(this).html();
           if($modalTagtext.includes('Tag:') || $modalTagtext.includes('Productdateunavailable:') || $modalTagtext.includes('Pdplink:') || $modalTagtext.includes('Onsalelabel:') || $modalTagtext.includes('SKU:') || $modalTagtext.includes('Category:')){
                   $(this).css('display','none');
           }
            if($modalTagtext.includes('Modaltitle:')){
                calendarTitle+='<div class="eapp-events-calendar-modal-title"><h3>'+$modalTagtext.split('Modaltitle:')[1]+'</h3></div>';
             $(calendarTitle).insertBefore('.eapp-events-calendar-popup-item-media');
             $(this).css('display','none');
           }
           if($modalTagtext.includes('Modaldescription:')){
                calendarDate+='<p class="copy-medium">'+$modalTagtext.split('Modaldescription:')[1]+'</p>';
             $('.eapp-events-calendar-popup-item-header').prepend(calendarDate);
             $(this).css('display','none');
           }
         })
         $('.eapp-events-calendar-drop-down-modal').addClass('eapp-events-calendar-drop-down-show');
         $('.eapp-events-calendar-drop-down-modal').prepend($('.eapp-events-calendar-drop-down-item:nth-child(3)'));
           //$('.eapp-events-calendar-drop-down-modal').prepend($('.eapp-events-calendar-drop-down-item:nth-child(3)'));
        $('.eapp-events-calendar-drop-down-modal .eapp-events-calendar-drop-down-item:first-child a').text('Outlook Calendar');
          setTimeout(function() {

             $('.eapp-events-calendar-event-viewer-modalContent').css('opacity','1');
        },350);

}
function gridFilterclick(){
     $('.eapp-events-calendar-filter-modal').on('click',function(e){
       setTimeout(function() {
              launchCalendar();
              gridEventclick();
       },300);

     });

}
    /* Address template set height for address item */
function setAddressheight(){
  var startIndex=0,endIndex,infoHeight=0,$gridItemcount=$('.customer-addresses__item').length;
  $.each($('.customer-addresses__item'),function(index){
           startIndex = startIndex;
         endIndex = startIndex + 1;
         if(index >= startIndex && index <= endIndex){
            var getInfoheight=$(this).height()+5;
            if(getInfoheight > infoHeight){
                infoHeight=getInfoheight;
            }
         }
         if($gridItemcount >= endIndex){
            if(index == endIndex){
                setAddressitemheight(startIndex,endIndex,infoHeight);
                startIndex=endIndex+1;
                infoHeight=0;
            }
         }
         else{
              setAddressitemheight(startIndex,$gridItemcount,infoHeight);
              infoHeight=0;
         }

  })
}
function setAddressitemheight(startIndex,endIndex,infoheight){
    $('.customer-addresses__item').each(function(index){
        if(index >= startIndex && index <= endIndex){
            if ($(window).width() >= 1024) {
            $(this).css('height',infoheight);
            }
        }
    })
}
/*gtag click events for form */
    var cspage = $('.form-track');

if(cspage.length>0){
  var contactInteraction=0;
  $('.template-page-contact #contact_form input,.template-page-contact #contact_form select,.template-page-contact #contact_form textarea').bind("touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup", function(e){
    if(contactInteraction==0){
      window.dataLayer.push({
         'event': 'form_start',
         'form_location' :'content_area',
         'form_name' : 'Contact Us'
       })
    }
    contactInteraction++;
  });
  function gtagformSubmit(formSubject,formname){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'form_submit',
      'form_name' : formname,
      'form_subject' : formSubject,
    });
  }
  function gtagformError(ele,errormsg){
       window.dataLayer.push({
       'event': 'form_submit',
       'form_location' : 'content_area',
       'form_name' : 'Contact Us',
       'form_error':errormsg,
       'form_error_field':ele
    })
  }
}

var cspage = $('#fedexform');
if(cspage.length>0)
{
  var returnInteraction=0;
  $('.template-page-returns #fedexform input,.template-page-returns #fedexform select').bind("touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup", function(e){
    if(returnInteraction==0){
      window.dataLayer.push({
         'event': 'form_start',
         'form_location' :'content_area',
         'form_name' : 'Return-policy'
       })
    }
    returnInteraction++;
  });
  function gtagformSubmit_return(location,formname){
       window.dataLayer.push({
       'event': 'form_submit',
       'form_location' : location,
       'form_name' : formname
    })
  }
  function gtagformError_return(ele,errormsg){
       window.dataLayer.push({
       'event': 'form_submit',
       'form_location' : 'content_area',
       'form_name' : 'Return Policy',
       'form_error':errormsg,
       'form_error_field':ele
    })
  }
}
var cspagereturn = $('.form-track-order');
if(cspagereturn.length>0)
{

  var orderInteraction=0;
  $('.template-page-orderstatus #order-status input').bind("touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup", function(e){
    if(orderInteraction==0){
      window.dataLayer.push({
         'event': 'form_start',
         'form_location' :'content_area',
         'form_name' : 'Order Status'
       })
    }
    orderInteraction++;
  });
  function gtagformSubmit_order(location,formname){
       window.dataLayer.push({
       'event': 'form_submit',
       'form_location' : location,
       'form_name' : formname
    })
  }
  function gtagformError_order(ele,errormsg){
       window.dataLayer.push({
       'event': 'form_submit',
       'form_location' : 'content_area',
       'form_name' : 'Order Status',
       'form_error':ele,
       'form_error_field':errormsg
    })
  }
}
/*Email signup form*/
if($('.email-signup-container.footer').length>0)
{
  var emailsignupInteraction=0;
  $(".email-signup-container.footer input, .email-signup-container.footer label").bind("touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup", function(e){
    if(emailsignupInteraction==0 && $(this).parents('.email-signup-container').hasClass('footer')){
      window.dataLayer.push({
         'event': 'form_start',
         'form_location' :'Footer',
         'form_name' : 'Email signup'
       })
    }
    emailsignupInteraction++;
  });

  function gtagformSubmit_email(location,formname){
       window.dataLayer.push({
       'event': 'form_submit',
       'form_location' : location,
       'form_name' : formname
    })
  }
  function gtagformError_email(ele,errormsg){
       window.dataLayer.push({
       'event': 'form_submit',
       'form_location' : 'Footer',
       'form_name' : 'Email signup',
       'form_error':ele,
       'form_error_field':errormsg
    })
  }
}

function gtagformSubmit_emailstandalone(location,formname){
  window.dataLayer.push({
    'event': 'form_submit',
    'form_location' : location,
    'form_name' : formname
  })
}

function gtagformError_emailstandalone(ele,errormsg){
  window.dataLayer.push({
    'event': 'form_submit',
    'form_location' : 'Content_area',
    'form_name' : 'Email signup',
    'form_error':ele,
    'form_error_field':errormsg
  })
}

/*Email signup form standalone*/
if($('.email-signup-container.soldout').length>0) {
  var emailsignupInteraction1=0;
  $(".email-signup-container.soldout input, .email-signup-container.soldout label").bind("touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup", function(e){
    if(emailsignupInteraction1==0 && $(this).parents('.email-signup-container').hasClass('soldout')){
      window.dataLayer.push({
         'event': 'form_start',
         'form_location' :'Content_area',
         'form_name' : 'Email signup'
       })
    }
    emailsignupInteraction1++;
  });
}
/*PDP Soldout */

if($('.pdp-soldout').length>0)
{

   var pdpsignupInteraction=0;
  $('.pdp-soldout input, .pdp-soldout label').bind("touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup", function(e){
    if(pdpsignupInteraction==0){
      window.dataLayer.push({
         'event': 'form_start',
         'form_location' :'content_area',
         'form_name' : 'PDP soldout Emailsignup'
       })
    }
    pdpsignupInteraction++;
  });

  function gtagformSubmit_pdpsoldout(location,formname){
       window.dataLayer.push({
       'event': 'form_submit',
       'form_location' : location,
       'form_name' : formname
    })
  }
  function gtagformError_pdpsoldout(ele,errormsg){
       window.dataLayer.push({
       'event': 'form_submit',
       'form_location' : 'content_area',
       'form_name' : 'PDP soldout Emailsignup',
       'form_error':ele,
       'form_error_field':errormsg
    })
  }
}
/* Globale modal country dropdown updates */
var selectvalue = [
  {optValue: 'US', optText: 'United States (USD &dollar;)', spritePosition:'0px -126px', modalMessage:"<span class='h3'>Mattel Creations ships to United States</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>", shopNowtext:"Shop Now", changeCountry:"Change Shipping country", countryModalmsg:"Change Shipping country", countryModalcontinue:"Continue", countryModalcancel:"Cancel"},
  {optValue: 'AU', optText: 'Australia (AUD &dollar;)', spritePosition:'0px -288px', modalMessage:"<span class='h3'>Mattel Creations ships to Australia</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in AUD</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only AUD 15 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>", shopNowtext:"Shop Now", changeCountry:"Change Shipping country", countryModalmsg:"CHANGE SHIPPING COUNTRY", countryModalcontinue:"Continue", countryModalcancel:"Cancel"},
  {optValue: 'AT', optText: 'Austria', spritePosition:'0px -180px', modalMessage:"<span class='h3'>Mattel Creations ships to Austria</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'BE', optText: 'Belgium', spritePosition:'0px -198px', modalMessage:"<span class='h3'>Mattel Creations ships to Belgium</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'CA', optText: 'Canada (CAD &dollar;)', spritePosition:'0px 0px', modalMessage:"<span class='h3'>Mattel Creations ships to Canada</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar; CAD</li><li>Product prices include duties where applicable to reflect true total product costs</li><li>No additional duties on toys at checkout.</li><li>Shipping fees have been upgraded, now only $13 CAD for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>", shopNowtext:"Shop Now", changeCountry:"Change Shipping country", countryModalmsg:"CHANGE SHIPPING COUNTRY", countryModalcontinue:"Continue", countryModalcancel:"Cancel"},
  {optValue: 'CZ', optText: 'Czech Republic', spritePosition:'0px -234px', modalMessage:"<span class='h3'>Mattel Creations ships to Czech Republic</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'FR', optText: 'France (EUR &euro;)', spritePosition:'0px -18px', modalMessage:"<span class='h3'>MATTEL CREATIONS LIVRE EN FRANCE</span><div class='recommendation-modal__benefits'><ul><li>Les prix sont indiqués en €</li><li>Les prix tiennent en compte des frais de douanes et de la t.v.a française en vigueur</li><li>Les frais de livraison ont été mis à jour, les frais standards ne sont plus qu’à 10€</li></ul></div><p class='thanku-text'>Merci d’avoir acheté sur Mattel Creations!</p>", shopNowtext:"Acheter Maintenant", changeCountry:"Changer Pays de Livraison", countryModalmsg:"CHANGER PAYS DE LIVRAISON", countryModalcontinue:"Continuer", countryModalcancel:"Annuler"},
  {optValue: 'DE', optText: 'Germany (EUR &euro;)', spritePosition:'0px -36px', modalMessage:"<span class='h3'>MATTEL CREATIONS LIEFERT NACH DEUTSCHLAND</span><div class='recommendation-modal__benefits'><ul><li>Die Produktpreise sind in € angegeben</li><li>Die Produktpreise enthalten Zölle und Steuern, um die tatsächlichen Gesamtkosten des Produkts widerzuspiegeln</li><li>Die Versandgebühren wurden geupdatet, jetzt nur noch 10€ für den Standardversand</li></ul></div><p class='thanku-text'>Vielen Dank für Ihren Einkauf bei Mattel Creations!</p>", shopNowtext:"Jetzt einkaufen", changeCountry:"Versandland ändern", countryModalmsg:"VERSANDLAND ÄNDERN", countryModalcontinue:"Weiter", countryModalcancel:"Absagen"},
  {optValue: 'HU', optText: 'Hungary', spritePosition:'0px -252px', modalMessage:"<span class='h3'>Mattel Creations ships to Hungary</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'IT', optText: 'Italy (EUR &euro;)', spritePosition:'0px -54px', modalMessage:"<span class='h3'>MATTEL CREATIONS SPEDISCE IN ITALIA</span><div class='recommendation-modal__benefits'><ul><li>I prezzi dei prodotti sono in &euro;</li><li>I prezzi dei prodotti includono tasse e imposte riflettendo già il vero costo totale</li><li>Le spese di spedizione sono state aggiornate: ora la spedizione standard costa solo 10&euro;</li></ul></div><p class='thanku-text'>Grazie per i tuoi acquisti Mattel Creations!</p>", shopNowtext:"Acquista Ora", changeCountry:"Cambia Paese di Spedizione", countryModalmsg:"CAMBIA PAESE DI SPEDIZIONE", countryModalcontinue:"Continua", countryModalcancel:"Annulla"},
  {optValue: 'JP', optText: 'Japan (JPY &yen;)', spritePosition:'0px -90px', modalMessage:"<span class='h3'>マテルクリエーション 日本へ発送について</span><div class='recommendation-modal__benefits'><ul><li>商品価格は円表示となっております</li><li>送料改定がございました。現在は通常配送にて&yen;1,400となります</li></ul></div><p class='thanku-text'>マテルクリエーションにてお買上頂きまして誠にありがとうございます！</p>", shopNowtext:"今すぐ購入", changeCountry:"配送先国を変更する", countryModalmsg:"配送先国を変更する", countryModalcontinue:"続ける", countryModalcancel:"キャンセル"},
  {optValue: 'MX', optText: 'Mexico (MXN &#8369;)', spritePosition:'0px -162px', modalMessage:"<span class='h3'>MATTEL CREATIONS ENVÍA A MÉXICO</span><div class='recommendation-modal__benefits'><ul><li>Los precios se muestran en pesos mexicanos (MXN)</li><li>Los precios de los productos incluyen tasas de importación e impuestos para reflejar los costos totales reales del producto.</li><li>Las tarifas de envío se han actualizado, ahora el costo del envío estándar es de MXN$200</li></ul></div><p class='thanku-text'>¡Gracias por comprar en Mattel Creations!</p>", shopNowtext:"Comprar Ahora", changeCountry:"Cambiar País de Envío", countryModalmsg:"Cambiar País de Envío", countryModalcontinue:"Continuar", countryModalcancel:"Cancelar"},
  {optValue: 'NL', optText: 'Netherlands', spritePosition:'0px -270px', modalMessage:"<span class='h3'>Mattel Creations ships to Netherlands</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'NZ', optText: 'New Zealand', spritePosition:'0px -378px', modalMessage:"<span class='h3'>Mattel Creations ships to New Zealand</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'PL', optText: 'Poland', spritePosition:'0px -306px', modalMessage:"<span class='h3'>Mattel Creations ships to Poland</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'PT', optText: 'Portugal', spritePosition:'0px -324px', modalMessage:"<span class='h3'>Mattel Creations ships to Portugal</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'SG', optText: 'Singapore', spritePosition:'0px -342px', modalMessage:"<span class='h3'>Mattel Creations ships to Singapore</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'ES', optText: 'Spain (EUR &euro;)', spritePosition:'0px -72px', modalMessage:"<span class='h3'>MATTEL CREATIONS HACE ENVÍOS A ESPAÑA</span><div class='recommendation-modal__benefits'><ul><li>Precio del producto mostrado en &euro;</li><li>El precio del producto lleva incluido tasas e impuestos para reflejar el costo total real del producto</li><li>Los gastos de envío han sido actualizados, ahora solo por &euro;10 el envío estándar </li></ul></div><p class='thanku-text'>Gracias por comprar Mattel Creations!</p>", shopNowtext:"Compra ahora", changeCountry:"Modifica Dirección de Envío", countryModalmsg:"MODIFICA DIRECCIÓN DE ENVÍO", countryModalcontinue:"Continuar", countryModalcancel:"Cancelar"},
  {optValue: 'CH', optText: 'Switzerland', spritePosition:'0px -360px', modalMessage:"<span class='h3'>Mattel Creations ships to Switzerland</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'GB', optText: 'United Kingdom (GBP &pound;)', spritePosition:'0px -108px', modalMessage:"<span class='h3'>Mattel Creations ships to United Kingdom</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &pound;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &pound;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>", shopNowtext:"Shop Now", changeCountry:"Change Shipping country", countryModalmsg:"Change Shipping country", countryModalcontinue:"Continue", countryModalcancel:"Cancel"}
];
var selectedcode;
$(document).on('click','.currency__changer_wrap_modal .select_content_modal li', function(e) {
   clickedV = $(this).find('a').attr('data-value');
  var imgWrap='';
  for(var i=0;i<selectvalue.length;i++){
      if(selectvalue[i].optValue == clickedV){
        imgWrap += '<img class="selectedflag" style="object-position:'+ selectvalue[i].spritePosition +'" src="https://cdn.shopify.com/s/files/1/0561/4790/2654/files/flag-updated-05-25.jpg" alt="Selected flag image" />'+$(this).text();
      }
  }
  $('.select_btn_modal').html(imgWrap);
  $(this).parents('.select_content_modal').find('li').removeClass('selected')
  $(this).addClass('selected');
});
$(document).on('click','.currency__changer_wrap_modal .select_btn_modal', function(e) {
  e.stopPropagation();
  $('.currency__changer_wrap_modal .select_btn_modal').next().toggleClass("hide");
  $('.currency__changer_wrap_modal .select_btn_modal').toggleClass("open");
});

$(document).on('click','.recommendation-modal__button', function(e) {
  e.preventDefault();
  var thisE = $(this);
  var cval = thisE.parents('form').find('.select_content_modal li.selected a').attr('data-value');
  if(cval == "rest"){
    cval = "US";
  }
  let localWrap = $(".locale-selectors__container");
  localWrap.find('.locale-selectors__selector').val(cval).change();
  localWrap.find('form').submit();
});
$(document).click(function(event) {
   event.stopPropagation();
    var container = $(".currency__changer_wrap_modal .select_btn_modal");
    if (!container.is(event.target) && !container.has(event.target).length) {
        if($('.currency__changer_wrap_modal .select_btn_modal').hasClass("open")){
          $('.currency__changer_wrap_modal .select_btn_modal').toggleClass("open");
          $('.currency__changer_wrap_modal .select_btn_modal').next().addClass("hide");
        }
    }
});
function globaleDrop() {

    var getvalue = setInterval(function() {
    var selectWrap = $(".locale-selectors__content .locale-selectors__selector");
    if(selectWrap.length > 0){
      let selectedV = selectWrap.find('option:selected').text();
      selectedcode = selectWrap.find('option:selected').attr('value');
      globaleCustomdrop(selectedcode,selectvalue,selectedV);
      clearInterval(getvalue);
    }
    }, 100);


  }
  function globaleCustomdrop(selectedcode,data,selectedV){
    var dropC = '';
    var selectedtext= selectedV.split('(')[0];
    var selectBtntext = selectedtext.length > 19 ? selectedtext.substring(0, 19) + '...' : selectedtext;
    for(var i=0;i<data.length;i++){
      if(data[i].optValue == selectedcode){
        dropC += '<span class="select_btn_modal"><img class="selectedflag" style="object-position:'+ data[i].spritePosition +'" src="https://cdn.shopify.com/s/files/1/0561/4790/2654/files/flag-updated-05-25.jpg" alt="Selected Flag Image" />'+selectBtntext+'</span>';
      }
    }
    dropC += '<div class="select_content_modal hide">';
    dropC += '<ul>';
    for(var i=0;i<=data.length;i++){
      if(typeof data[i] != 'undefined'){
        var flagSrc = "https://flagcdn.com/48x36/"+data[i].optValue.toLowerCase()+".png";
        dropC += '<li>'
        dropC += '<img class="flag'+i+'" style="object-position:'+ data[i].spritePosition +'" src="https://cdn.shopify.com/s/files/1/0561/4790/2654/files/flag-updated-05-25.jpg" alt="Selected Flag Image" /><a href="javascript:void(0)" data-value="'+data[i].optValue+'">'+data[i].optText.split('(')[0]+'</a>';
        dropC += '</li>';
      }
    }
    dropC += '</ul>';
    dropC += '</div>';
    $(".currency__changer_wrap_modal .changer_content_modal").html(dropC);
  }

$(document).on('click','.show-country-modal', function(e) {
  $('.country_changer_modal').show();
  $('.globale_welcome_modal').hide();
});
$(document).on('click','.globale-close-button,.recommendation-modal__backdrop',function(e){
  setCookie('globalemodalClose','true');
  $('.recommendation-modal__backdrop,.recommendation-modal__container').hide();
});
function globaleWelcome(){
  var readLocale = sessionStorage.GLBE_geo;
  var readLocalefromCookie = $.cookie("localization");
  var setLocale;
  readLocale == readLocalefromCookie ? setLocale = readLocale : setLocale = readLocalefromCookie;
  if (
    setLocale == "CA" ||
    setLocale == "FR" ||
    setLocale == "DE" ||
    setLocale == "ES" ||
    setLocale == "IT" ||
    setLocale == "GB" ||
    setLocale == "UK" ||
    setLocale == "JP" ||
    setLocale == "AU" ||
    setLocale == "MX" ||
    setLocale == "PL" ||
    setLocale == "NL" ||
    setLocale == "CZ" ||
    setLocale == "AT" ||
    setLocale == "PT" ||
    setLocale == "SG" ||
    setLocale == "BE" ||
    setLocale == "HU" ||
    setLocale == "CH" ||
    setLocale == "BR" ||
    setLocale == "NZ"
  ) {
    if($.cookie("globalemodalClose")==null  || $.cookie("globalemodalClose")=="false" || $.cookie("globalemodalClose")== undefined ){
        $('.globale_welcome_modal,.recommendation-modal__backdrop').show();
      }
  }
  for(var i=0;i<selectvalue.length;i++){
    if(setLocale == selectvalue[i].optValue){
      $('.globale_welcome_modal .globale-shipping-msg').html(selectvalue[i].modalMessage);
      $('.recommendation-modal__content .globale-close-button').text(selectvalue[i].shopNowtext);
      $('.globale_welcome_modal .show-country-modal').text(selectvalue[i].changeCountry);
      $('.country_changer_modal h3').text(selectvalue[i].countryModalmsg);
      $('.country_changer_modal button').text(selectvalue[i].countryModalcontinue);
      $('.country_changer_modal .recommendation-modal__content .globale-close-button').text(selectvalue[i].countryModalcancel);
    }
  }
}
/*Determine element is in viewport*/
$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
function launchCustomcalendar(){
  var gridW = $(".calendar-grid-component");
  $('.calendar-loader').append('<div class="loaderelement"></div>');
  $('.calendar-loader').addClass('showloader');
  var filterDrops=[];
  var filterContainer='';
  filterContainer+='<div class="cfilter-content"><div class="filter-items">';
  filterContainer+='<div class="filter-selected"><div class="filter-selected-text">All Brands</div></div><div class="filter-dropmenu hide"><ul>';
  $('.calendar-grid-component .calendar-grid-item').each(function(i,ele){
    var tile_badge=$(this).find('.detail-atc-container .citem-vendor').text();
    if(i==0){
      filterContainer+='<li style="display:none;"><a>All Brands</a></li>';
    }
    if($.inArray(tile_badge, filterDrops) == -1){
      filterDrops.push(tile_badge);
      filterContainer+='<li><a>'+tile_badge+'</a></li>';
    }
  });
  filterContainer+='</ul></div></div></div>';
  $('.cfilter-wrapper').html(filterContainer);
   var checkItemexist = setInterval(function() {
       if ($('.calendar-grid-item').length) {
          clearInterval(checkItemexist);
          $('.calendar-grid-component').css('height','auto').css('opacity','1');
          $('.past-events').wrapAll('<div class="calendar-past-events" />');
          $( ".calendar-past-events" ).prepend( "<h5 class='past-eventstitle'>Past Events</h5>" );
          $('.active-events').wrapAll('<div class="calendar-active-events" />');
          $('.calendar-active-events').insertBefore($('.calendar-past-events'));
          $('.past-eventstitle').insertAfter($('.calendar-active-events'));
          if($('.calendar-past-events').is(':empty')){
            $('.past-eventstitle').addClass('hide');
          }
          setTiles($('.calendar-grid-item'));
          addCalendar();
          $('.calendar-loader').removeClass('showloader');
          $('.calendar-loader').html('');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
     }, 100);
  $('.filter-selected').on('click',function(){
    $('.filter-dropmenu').toggleClass('hide');
  });
  $('.filter-dropmenu ul li').on('click',function(){
    var dropPastitems ='';
    var dropPastcontainer='';
    var dropActiveitems ='';
    var dropActivecontainer='';
    var filteredEvents = false;
    $('.calendar-past-events,.calendar-active-events').show();
    $('.calendar-filtered-activeevents,.calendar-filtered-pastevents').remove();
    $('.filter-dropmenu').toggleClass('hide');
    var selectedText=$(this).text();
    selectedText == "All Brands" ? $('.filter-dropmenu ul li:first-child').hide() : $('.filter-dropmenu ul li:first-child').show()
    $('.cfilter-wrapper .filter-selected .filter-selected-text').text(selectedText);
    $('.calendar-loader').addClass('showloader');
     $('.calendar-loader').append('<div class="loaderelement"></div>');
    $('.calendar-grid-component').css('height','100px').css('opacity','0');
    $('.calendar-grid-component .calendar-grid-item,.past-eventstitle').removeClass('hide');
    if(selectedText != "All Brands"){
      $('.calendar-grid-component .calendar-grid-item').each(function(i,ele){
        var merch_badge=$(this).find('.detail-atc-container .citem-vendor').text();
        if(selectedText != merch_badge){
          $(this).addClass('hide');
        }
        else{
          filteredEvents=true;
          if($(this).hasClass('past-events')){
            $('.calendar-past-events').hide();
            dropPastitems+='<div class="calendar-grid-item past-events filtered-events">'+$(this).html()+'</div>';
          }
          else if($(this).hasClass('active-events')){
            $('.calendar-active-events').hide();
            dropActiveitems+='<div class="calendar-grid-item active-events filtered-events">'+$(this).html()+'</div>';
          }
        }
      });
      if(filteredEvents){
        dropActivecontainer +='<div class="calendar-filtered-activeevents calendar-active-events">'+dropActiveitems+'</div>';
        $('.calendar-grid-component').append(dropActivecontainer);
        $('.calendar-filtered-activeevents').insertBefore('.past-eventstitle');
        dropPastcontainer +='<div class="calendar-filtered-pastevents calendar-past-events">'+dropPastitems+'</div>';
        $('.calendar-grid-component').append(dropPastcontainer);
        if($('.calendar-filtered-pastevents').is(':empty')){
          $('.past-eventstitle').addClass('hide');
        }
        setTiles($('.filtered-events'));
        addCalendar();
      }
    }
    setTimeout(function(){

      $('.calendar-grid-component').css('height','auto').css('opacity','1');
      $('.calendar-loader').removeClass('showloader');
      $('.calendar-loader').html('');
    },500);

  });
  $(document).click(function(event) {
    var container = $(".calendar-filter-section .cfilter-content");
    if (!container.is(event.target) && !container.has(event.target).length) {
        if(!$('.filter-dropmenu').hasClass("open")){
          $('.filter-dropmenu').addClass("hide");
        }
    }
 });

     var imageC = $(".calendar-image-container .img-gallery");
     imageC.on('init', function(event, slick){
        gridW.removeClass("loadEffect");
      $('.calendar-loader').removeClass('showloader');
      });
  if(imageC.find('img').length>0){
    imageC.slick({
      arrows: true,
      nextArrow: '<button class="next-btn">&nbsp;</button>',
      prevArrow: '<button class="left-btn">&nbsp;</button>'
    });
  }
}
 /*CTA click*/
function addCalendar(){
$('.cbutton-wrapper').on('click',function(){
     $('body').append('<div class="calendar-modal-overlay-component"></div>');
     $('.calendar-modal-wrapper').removeClass('hide');

     var modalContainer='';
     var modalImgSrc = $(this).parents('.calendar-grid-item').find('#popupImg').attr("src");

     modalContainer+='<div class="atc-heading">ADD TO CALENDAR</div>';
     modalContainer+='<div class="calendar-modal-close"><span class="calendar-close-icon"></span></div>';
     modalContainer+='<div class="calendar-popup-img-container"><img class="calendar-popup-img" src='+modalImgSrc+' alt="Calendar Popup Image"></div>';

     var modalTitle=$(this).parents('.calendar-grid-item').find('#summary').val();
     var modalDesc=$(this).parents('.calendar-grid-item').find('#description').val();
     var modalPrice=$(this).parents('.calendar-grid-item').find('.calendar-detail-container .citem-price').text();
     var modalTimeField=$(this).parents('.calendar-grid-item').find('.time-field').text();
     var icsDate=$(this).parents('.calendar-grid-item').find('#startDate').val();
     var googleDate=$(this).parents('.calendar-grid-item').find('#googleDate').val();

     modalContainer+='<div class="modal-description-section"><h3 class="modal-time">'+modalTimeField+'</h3><h3 class="modal-title">'+modalTitle+'</h3>';
     modalContainer+='<p class="copy-medium modal-desc">'+modalDesc+'</p><p class="copy-medium modal-price">'+modalPrice+'</p></div>';
     modalContainer+='<div class="modal-button-container"><div class="outlook-wrapper calender-button"><a href="#" class="ical-icon outlook-icon">Outlook calendar</a></div><div class="apple-wrapper calender-button"><a class="ical-icon apple-icon">Apple Calendar</a></div><div class="google-wrapper calender-button"><a class="google-icon" href="http://www.google.com/calendar/event?action=TEMPLATE&text='+modalTitle+'&dates='+googleDate+'/'+googleDate+'&details='+modalDesc+'">Google Calendar</a></div><div class="calender-button"><a class="otc-btn ical-icon">Other Calendar</a></div></div>';

    var saveAs=saveAs||function(e){"use strict";if(typeof e==="undefined"||typeof navigator!=="undefined"&&/MSIE [1-9]\./.test(navigator.userAgent)){return}var t=e.document,n=function(){return e.URL||e.webkitURL||e},r=t.createElementNS("http://www.w3.org/1999/xhtml","a"),o="download"in r,a=function(e){var t=new MouseEvent("click");e.dispatchEvent(t)},i=/constructor/i.test(e.HTMLElement)||e.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),u=function(t){(e.setImmediate||e.setTimeout)(function(){throw t},0)},s="application/octet-stream",d=1e3*40,c=function(e){var t=function(){if(typeof e==="string"){n().revokeObjectURL(e)}else{e.remove()}};setTimeout(t,d)},l=function(e,t,n){t=[].concat(t);var r=t.length;while(r--){var o=e["on"+t[r]];if(typeof o==="function"){try{o.call(e,n||e)}catch(a){u(a)}}}},p=function(e){if(/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)){return new Blob([String.fromCharCode(65279),e],{type:e.type})}return e},v=function(t,u,d){if(!d){t=p(t)}var v=this,w=t.type,m=w===s,y,h=function(){l(v,"writestart progress write writeend".split(" "))},S=function(){if((f||m&&i)&&e.FileReader){var r=new FileReader;r.onloadend=function(){var t=f?r.result:r.result.replace(/^data:[^;]*;/,"data:attachment/file;");var n=e.open(t,"_blank");if(!n)e.location.href=t;t=undefined;v.readyState=v.DONE;h()};r.readAsDataURL(t);v.readyState=v.INIT;return}if(!y){y=n().createObjectURL(t)}if(m){e.location.href=y}else{var o=e.open(y,"_blank");if(!o){e.location.href=y}}v.readyState=v.DONE;h();c(y)};v.readyState=v.INIT;if(o){y=n().createObjectURL(t);setTimeout(function(){r.href=y;r.download=u;a(r);h();c(y);v.readyState=v.DONE});return}S()},w=v.prototype,m=function(e,t,n){return new v(e,t||e.name||"download",n)};if(typeof navigator!=="undefined"&&navigator.msSaveOrOpenBlob){return function(e,t,n){t=t||e.name||"download";if(!n){e=p(e)}return navigator.msSaveOrOpenBlob(e,t)}}w.abort=function(){};w.readyState=w.INIT=0;w.WRITING=1;w.DONE=2;w.error=w.onwritestart=w.onprogress=w.onwrite=w.onabort=w.onerror=w.onwriteend=null;return m}(typeof self!=="undefined"&&self||typeof window!=="undefined"&&window||this.content);if(typeof module!=="undefined"&&module.exports){module.exports.saveAs=saveAs}else if(typeof define!=="undefined"&&define!==null&&define.amd!==null){define("FileSaver.js",function(){return saveAs})}
    var ics=function(e,t){"use strict";{if(!(navigator.userAgent.indexOf("MSIE")>-1&&-1==navigator.userAgent.indexOf("MSIE 10"))){void 0===e&&(e="default"),void 0===t&&(t="Calendar");var r=-1!==navigator.appVersion.indexOf("Win")?"\r\n":"\n",n=[],i=["BEGIN:VCALENDAR","PRODID:"+t,"VERSION:2.0"].join(r),o=r+"END:VCALENDAR",a=["SU","MO","TU","WE","TH","FR","SA"];return{events:function(){return n},calendar:function(){return i+r+n.join(r)+o},addEvent:function(t,i,o,l,u,s){if(void 0===t||void 0===i||void 0===o||void 0===l||void 0===u)return!1;if(s&&!s.rrule){if("YEARLY"!==s.freq&&"MONTHLY"!==s.freq&&"WEEKLY"!==s.freq&&"DAILY"!==s.freq)throw"Recurrence rrule frequency must be provided and be one of the following: 'YEARLY', 'MONTHLY', 'WEEKLY', or 'DAILY'";if(s.until&&isNaN(Date.parse(s.until)))throw"Recurrence rrule 'until' must be a valid date string";if(s.interval&&isNaN(parseInt(s.interval)))throw"Recurrence rrule 'interval' must be an integer";if(s.count&&isNaN(parseInt(s.count)))throw"Recurrence rrule 'count' must be an integer";if(void 0!==s.byday){if("[object Array]"!==Object.prototype.toString.call(s.byday))throw"Recurrence rrule 'byday' must be an array";if(s.byday.length>7)throw"Recurrence rrule 'byday' array must not be longer than the 7 days in a week";s.byday=s.byday.filter(function(e,t){return s.byday.indexOf(e)==t});for(var c in s.byday)if(a.indexOf(s.byday[c])<0)throw"Recurrence rrule 'byday' values must include only the following: 'SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'"}}var g=new Date(l),d=new Date(u),f=new Date,S=("0000"+g.getFullYear().toString()).slice(-4),E=("00"+(g.getMonth()+1).toString()).slice(-2),v=("00"+g.getDate().toString()).slice(-2),y=("00"+g.getHours().toString()).slice(-2),A=("00"+g.getMinutes().toString()).slice(-2),T=("00"+g.getSeconds().toString()).slice(-2),b=("0000"+d.getFullYear().toString()).slice(-4),D=("00"+(d.getMonth()+1).toString()).slice(-2),N=("00"+d.getDate().toString()).slice(-2),h=("00"+d.getHours().toString()).slice(-2),I=("00"+d.getMinutes().toString()).slice(-2),R=("00"+d.getMinutes().toString()).slice(-2),M=("0000"+f.getFullYear().toString()).slice(-4),w=("00"+(f.getMonth()+1).toString()).slice(-2),L=("00"+f.getDate().toString()).slice(-2),O=("00"+f.getHours().toString()).slice(-2),p=("00"+f.getMinutes().toString()).slice(-2),Y=("00"+f.getMinutes().toString()).slice(-2),U="",V="";y+A+T+h+I+R!=0&&(U="T"+y+A+T,V="T"+h+I+R);var B,C=S+E+v+U,j=b+D+N+V,m=M+w+L+("T"+O+p+Y);if(s)if(s.rrule)B=s.rrule;else{if(B="rrule:FREQ="+s.freq,s.until){var x=new Date(Date.parse(s.until)).toISOString();B+=";UNTIL="+x.substring(0,x.length-13).replace(/[-]/g,"")+"000000Z"}s.interval&&(B+=";INTERVAL="+s.interval),s.count&&(B+=";COUNT="+s.count),s.byday&&s.byday.length>0&&(B+=";BYDAY="+s.byday.join(","))}(new Date).toISOString();var H=["BEGIN:VEVENT","UID:"+n.length+"@"+e,"CLASS:PUBLIC","DESCRIPTION:"+i,"DTSTAMP;VALUE=DATE-TIME:"+m,"DTSTART;VALUE=DATE-TIME:"+C,"DTEND;VALUE=DATE-TIME:"+j,"LOCATION:"+o,"SUMMARY;LANGUAGE=en-us:"+t,"TRANSP:TRANSPARENT","END:VEVENT"];return B&&H.splice(4,0,B),H=H.join(r),n.push(H),H},download:function(e,t){if(n.length<1)return!1;t=void 0!==t?t:".ics",e=void 0!==e?e:"calendar";var a,l=i+r+n.join(r)+o;if(-1===navigator.userAgent.indexOf("MSIE 10"))a=new Blob([l]);else{var u=new BlobBuilder;u.append(l),a=u.getBlob("text/x-vCalendar;charset="+document.characterSet)}return saveAs(a,e+t),l},build:function(){return!(n.length<1)&&i+r+n.join(r)+o}}}console.log("Unsupported Browser")}};
    cal_single = ics();
    cal_single.addEvent( modalTitle , modalDesc , '',icsDate, icsDate);

     $('.calendar-modal-container').html(modalContainer);
     $('.ical-icon').on('click',function(){
        cal_single.download(modalTitle);
     });
      $('.calendar-modal-close .calendar-close-icon,.calendar-modal-overlay-component').on('click',function(){
        $('.calendar-modal-overlay-component').remove();
        $('.calendar-modal-wrapper').addClass('hide');
      });
});

}
/*$('.calendar-modal-wrapper').on('click','.ical-icon',function(){
// $('.ical-icon').on('click',function(){
        cal_single.download(modalTitle);
}); */
function setTiles(ele){
  var $gridItemcount;
       var isPastgridItem = false;
       var startIndex=0,endIndex;
       var infoHeight=0,dateHeight=0,tileHeight=0,imageHeight=0;
       ele.each(function(index){
      /*Truncate and show elipsis */
          eventName = $(this).find('.citem-title').text();
          truncateProdname(eventName,$(this).find('.citem-title'));
         /*set min height based on grid info */
         startIndex = startIndex ;
         endIndex = startIndex + 2;
         if(index >= startIndex && index <= endIndex){
            var getInfoheight=$(this).find('.calendar-detail-container').height();
            if(getInfoheight > infoHeight){
                infoHeight=getInfoheight;
            }
            var getDatefieldHeight=$(this).find('.calendar-date-container').height()+40;
            if(getDatefieldHeight > dateHeight){
                dateHeight=getDatefieldHeight;
            }
            var getTileheight=$(this).find('.detail-atc-container').height();
            if(getTileheight > tileHeight){
                tileHeight=getTileheight;
            }
            var getImageheight=$(this).find('.calendar-image-container').height();
            if(getImageheight > imageHeight){
                imageHeight=getImageheight;
            }
         }
         if($(this).closest('.calendar-past-events').length){
           $gridItemcount=$('.calendar-past-events .calendar-grid-item').length-1;
           $gridItemcount=$gridItemcount+$activeEvents;
           isPastgridItem=true;
         }
         else{
           $gridItemcount = $('.calendar-active-events .calendar-grid-item').length-1;
           $activeEvents=$gridItemcount;
         }
         if($gridItemcount >= endIndex){
            if(index == endIndex){
                setCalendarheight(startIndex,endIndex,infoHeight,dateHeight,tileHeight,imageHeight,isPastgridItem,ele);
                startIndex=endIndex+1;
                infoHeight=0;
                dateHeight=0;
                tileHeight=0;
                imageHeight=0;
            }
         }
         else if(!isPastgridItem){
           if(index == $gridItemcount){
             setCalendarheight(startIndex,$gridItemcount,infoHeight,dateHeight,tileHeight,imageHeight,isPastgridItem,ele);
             startIndex=$gridItemcount+1;
              infoHeight=0;
              dateHeight=0;
              tileHeight=0;
              imageHeight=0;
           }
         }
         else{
              setCalendarheight(startIndex,endIndex,infoHeight,dateHeight,tileHeight,imageHeight,isPastgridItem,ele);
           }
      });
     // addCalendar();
}
function setCalendarheight(startIndex,endIndex,infoheight,dateHeight,tileHeight,imageHeight,isPastgridItem,ele){
    const blocksAreUsed = $('.calendar-section--blocks').length > 0;
    ele.each(function(index){
        if(index >= startIndex && index <= endIndex && blocksAreUsed){
            if ($(window).width() >= 1024) {
            $(this).find('.calendar-detail-container').css('height',infoheight);
            $(this).find('.calendar-date-container').css('height',dateHeight);
            $(this).find('.detail-atc-container').css('height',tileHeight);
            $(this).find('.calendar-image-container').css('height',imageHeight);
            }
        }
    })
}
$(window).on('resize scroll', function() {
  $('.container-pastprojects .grid__cell').each(function(){
    if($(this).isInViewport()){
      if($(this).find('.video-container').hasClass('autoplay')){
        $(this).find("video").prop('autoplay','true');
        $(this).find("video").prop('muted','true');
        $(this).find("video").get(0).play();
      }
       if($(this).find('.video-container').hasClass('loop')){
        $(this).find("video").prop('loop','true');
      }
      if(!$(this).find('.video-container').hasClass('controls')){
        $(this).find(".vjs-control-bar").css('display','none');
      }
    }

  });
});
